
// Mixins
import confirmDialogMixin from '@/mixins/cd.mixin.js'

// Constants
import dateTimeLanguage from '@/constants/dateTimeLanguage'
import {
  DETALHES_PLANTAO_APAGAR,
  DETALHES_PLANTAO_DIVIDIR,
  DETALHES_PLANTAO_ALTERAR,
  DETALHES_PLANTAO_PERSONALIZAR_REGISTRO,
  GRUPO_VER_VALORES,
} from '@/constants'

// import { getSeriesTypeLabel } from '@/constants/series'
import { SERIES_DAY_OFF, SERIES_VACATION } from '@/constants/series'

// Api
import { apiGetUserDetails, apiGetUserId } from '@/services/firebase'
import { getDutyByID, getShiftPause, apiAcceptDuty, apiRefuseDuty, apiUpdateDuty, apiUpdateCheckin, apiUpdateShiftOwner, apiCancelShiftRequest, apiDeleteDuty, apiGetShiftHistory, apiUndoShiftExecutionTime, apiStartDuty, apiFinishDuty, apiDeleteCheckout, apiUpdatePause } from '@/services/duties'

// Utilitários
import { valueToTime, canAddUserShift, isShiftExpiredNew } from '@/functions'
import { durationIsTwoHoursOrMore, formatMoney, formatDuration, getShiftBalance } from '@/mixins/utils'

// Imagens
import userProfileBroken from '@/assets/images/user-profile-broken.png'
import userProfileCancelado from '@/assets/images/duty-status-cancelado.png'
import userProfileAvailable from '@/assets/images/duty-status-available.png'
import dutyEdited from '@/assets/images/duty-edited.png'
import dutyStatusOwned from '@/assets/images/duty-status-caught.png'
import dutyStatusFinished from '@/assets/images/duty-status-finished.png'
import dutyStatusStarted from '@/assets/images/duty-status-started.png'

// Componentes
import GroupTab from '@/components/GroupTab'
import AppMoneyLight from '@/components/base/AppMoneyLight'
import SosButton from '@/components/SosButton'
import SosCheckbox from '@/components/SosCheckbox'

// Modals / Dialogs
import ConfirmDialog from '@/modals/ConfirmDialog'
import SplitShift from '@/modals/splitshift'

// ?
import { mapState } from 'vuex'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

// Moment JS
import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

// Regras de carga horária
import { durationHoursToMinutes, buildStartAtISO } from '@/functions/workingHours'

const footerProps = {
  // showFirstLastPage: true,
  // firstIcon: 'mdi-arrow-collapse-left',
  // lastIcon: 'mdi-arrow-collapse-right',
  prevIcon: 'mdi-minus',
  nextIcon: 'mdi-plus',
  'items-per-page-text': 'Linhas por página:',
  'items-per-page-all-text': 'Todos',
  'items-per-page-options': [5, 10, -1],
  'page-text': '{0}-{1} de {2}',
}

const candidatesHeader = [
  { text: 'Profissional', value: 'applicationTime' },
  { width: 190, sortable: false, text: 'Ações', value: 'user_action' },
]

const headers = [
  { width: 185, text: 'Data', value: 'date' },
  { sortable: false, text: 'Evento', value: 'evento' },
  { sortable: false, text: 'Status', value: 'status' },
]

function compareObjects (obj1, obj2) {
  const keys1 = !!obj1 === true ? Object.keys(obj1) : []
  const keys2 = !!obj2 === true ? Object.keys(obj2) : []

  const addedKeys = keys2.filter(key => !keys1.includes(key))
  const deletedKeys = keys1.filter(key => !keys2.includes(key))

  return { addedKeys, deletedKeys }
}

//
//
//

const fmtAN = adminName => `<span style="color: #e54245; font-weight: 500">${adminName}</span>`

const fmtUN = userName => `<span style="color: #4682b4; font-weight: 500">${userName}</span>`

const formatDutyAssigned = (log, afterDetails, eventOwnerProfile) => {
  // identificar quando o admin atribui um plantonista
  const changedByOwner = log.uid === afterDetails.owner.userID
  const eventoImage = changedByOwner ? afterDetails.owner.userImage : eventOwnerProfile.userImage
  const eventoText = changedByOwner ? `${fmtUN(afterDetails.owner.userName)} assumiu o plantão disponível` : `${fmtAN(eventOwnerProfile.userName)} atribuiu ${fmtUN(afterDetails.owner.userName)} como plantonista` // do plantão disponível
  const statusImage = afterDetails.owner.userImage
  const statusText = `Assumido por ${fmtUN(afterDetails.owner.userName)}`
  return { evento: { image: eventoImage, text: eventoText }, status: { image: statusImage, text: statusText } }
}

const formatDutyDropped = (log, beforeDetails, eventOwnerProfile) => {
  // identificar quando é passado por admin
  const changedByOwner = log.uid === beforeDetails.owner.userID
  const eventoImage = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
  const eventoText = changedByOwner ? `${fmtUN(beforeDetails.owner.userName)} passou o plantão para o grupo` : `${fmtAN(eventOwnerProfile.userName)} passou o plantão de ${fmtUN(beforeDetails.owner.userName)} para o grupo`
  const statusImage = userProfileAvailable
  const statusText = 'Plantão aberto'
  return { evento: { image: eventoImage, text: eventoText }, status: { image: statusImage, text: statusText } }
}

const formatNewAssignedDuty = ({ afterDetails, eventOwnerProfile }) => {
  const doneByManager = afterDetails.owner.userID !== eventOwnerProfile.userID

  const eventoImage = afterDetails.creator.userImage
  const eventoText = doneByManager ? `${fmtAN(afterDetails.creator.userName)} criou o plantão para ${fmtUN(afterDetails.owner.userName)}` : `${fmtUN(afterDetails.owner.userName)} criou o plantão`

  const statusImage = afterDetails.owner.userImage
  const statusText = `${fmtUN(afterDetails.owner.userName)} recebeu um novo plantão`
  return {
    evento: { image: eventoImage, text: eventoText },
    status: { image: statusImage, text: statusText }
  }
}

const formatNewSplitedDuty = ({ afterDetails, eventOwnerProfile }) => {
  const doneByManager = afterDetails.owner.userID !== eventOwnerProfile.userID

  const eventoImage = afterDetails.creator.userImage
  const eventoText = doneByManager ? `${fmtAN(afterDetails.creator.userName)} dividiu o plantão para ${fmtUN(afterDetails.owner.userName)}` : `${fmtUN(afterDetails.owner.userName)} dividiu o plantão`

  const statusImage = afterDetails.owner.userImage
  const statusText = `${fmtUN(afterDetails.owner.userName)} recebeu um novo plantão`
  return {
    evento: { image: eventoImage, text: eventoText },
    status: { image: statusImage, text: statusText }
  }
}

const formatNewAvailableDuty = afterDetails => {
  const eventoImage = afterDetails.creator.userImage
  const eventoText = `${fmtAN(afterDetails.creator.userName)} criou o plantão para o grupo`
  const statusImage = userProfileAvailable
  const statusText = 'Plantão aberto'
  return { evento: { image: eventoImage, text: eventoText }, status: { image: statusImage, text: statusText } }
}

const formatDutyShared = (log, afterDetails, beforeDetails, eventOwnerProfile) => {
  // identificar quando é passado por admin
  const changedByOwner = log.uid === beforeDetails.owner.userID
  const eventoImage = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
  const eventoText = changedByOwner ? `${fmtUN(beforeDetails.owner.userName)} passou para ${fmtUN(afterDetails.owner.userName)}` : `${fmtAN(eventOwnerProfile.userName)} passou o plantão de ${fmtUN(beforeDetails.owner.userName)} para ${fmtUN(afterDetails.owner.userName)}`
  const statusImage = afterDetails.owner.userImage
  const statusText = `${fmtUN(afterDetails.owner.userName)} recebeu o plantão`
  return { evento: { image: eventoImage, text: eventoText }, status: { image: statusImage, text: statusText } }
}

const formatDutyCancelled = (log, afterDetails, beforeDetails, eventOwnerProfile) => {
  // identificar quando é passado por admin
  const changedByOwner = log.uid === beforeDetails.owner.userID
  const eventoImage = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
  const eventoText = changedByOwner ? (
    `Cancelado por ${fmtUN(beforeDetails.owner.userName)}`
  ) : (
    `Plantão de ${fmtUN(beforeDetails.owner.userName)} cancelado por ${fmtAN(eventOwnerProfile.userName)}`
  )
  const statusImage = userProfileCancelado
  const statusText = 'Plantão cancelado'
  // const statusImage = afterDetails.owner.userImage
  /// const statusText = `${fmtUN(afterDetails.owner.userName)} recebeu o plantão`
  return { evento: { image: eventoImage, text: eventoText }, status: { image: statusImage, text: statusText } }
}

const formatDutyStarted = ({
  afterDetails,
  eventOwnerProfile
}) => {
  const doneByManager = afterDetails.owner.userID !== eventOwnerProfile.userID

  const eventoImage = doneByManager ? eventOwnerProfile.userImage : afterDetails.owner.userImage
  const eventoText = doneByManager ? `${fmtAN(eventOwnerProfile.userName)} iniciou o plantão de ${fmtUN(afterDetails.owner.userName)}` : `${fmtUN(afterDetails.owner.userName)} iniciou o plantão`
  const statusImage = dutyStatusStarted
  const statusText = 'Plantão iniciado'

  return {
    evento: { image: eventoImage, text: eventoText },
    status: { image: statusImage, text: statusText }
  }
}

const formatDutyFinished = ({
  afterDetails,
  eventOwnerProfile
}) => {
  const doneByManager = afterDetails.owner.userID !== eventOwnerProfile.userID

  const eventoImage = doneByManager ? eventOwnerProfile.userImage : afterDetails.owner.userImage
  const eventoText = doneByManager ? `${fmtAN(eventOwnerProfile.userName)} encerrou o plantão de ${fmtUN(afterDetails.owner.userName)}` : `${fmtUN(afterDetails.owner.userName)} encerrou o plantão`
  const statusImage = dutyStatusFinished
  const statusText = 'Plantão encerrado'

  return {
    evento: { image: eventoImage, text: eventoText },
    status: { image: statusImage, text: statusText }
  }
}

const formatCheckinUpdated = ({ afterDetails, eventOwnerProfile }) => {
  const startLocation = afterDetails.start_location;
  let eventoText;
  let statusText = 'Check-in alterado';
  let eventoImage = eventOwnerProfile.userImage;
  let statusImage = dutyEdited;

  if (startLocation && startLocation.timestamp) {
    const newTime = moment(startLocation.timestamp * 1).format('DD/MM/YYYY [às] HH:mm:ss');
    statusText = `Novo check-in em ${newTime}`;
    eventoText = `${fmtAN(eventOwnerProfile.userName)} editou o inicio do plantão de ${fmtUN(afterDetails.owner.userName)}`;
  } else {
    eventoText = `${fmtAN(eventOwnerProfile.userName)} alterou o check-in (dados não disponíveis)`;
  }

  return {
    evento: { image: eventoImage, text: eventoText },
    status: { image: statusImage, text: statusText }
  }
}

const formatCheckoutDeleted = ({ eventOwnerProfile, afterDetails }) => {
  const eventoText = `${fmtAN(eventOwnerProfile.userName)} apagou o check-out de ${fmtUN(afterDetails.owner.userName)}`;
  const statusText = 'Plantão em andamento';

  return {
    evento: { image: eventOwnerProfile.userImage, text: eventoText },
    status: { image: dutyStatusStarted, text: statusText }
  }
}

const formatPauseUpdated = ({ afterDetails, eventOwnerProfile }) => {
  const pause = afterDetails.pause || {};
  const ownerName = afterDetails.owner.userName || 'plantonista';

  const editedStart = pause.type === 'start';
  const timestamp = editedStart ? pause.start_timestamp : pause.end_timestamp;

  const defaultStatusText = editedStart ? 'Pausa alterada' : 'Retorno da pausa alterado';
  const dateText = timestamp ? moment(timestamp * 1).format('DD/MM/YYYY [às] HH:mm:ss') : '';

  return {
    evento: {
      image: eventOwnerProfile.userImage,
      text: editedStart
        ? `${fmtAN(eventOwnerProfile.userName)} editou o início da pausa de ${fmtUN(ownerName)}`
        : `${fmtAN(eventOwnerProfile.userName)} editou o retorno da pausa de ${fmtUN(ownerName)}`,
    },
    status: {
      image: dutyEdited,
      text: dateText.length > 0
        ? `${editedStart ? 'Nova pausa em' : 'Novo retorno em'} ${dateText}`
        : defaultStatusText,
    },
  }
}

//
//
//

const getHistoryDetails = async shift =>
{
  let details = {
    status: '',
    creator: { userID: '', userName: '', userImage: userProfileBroken },
    owner: { userID: '', userName: '', userImage: userProfileBroken },
    value: 0,
    obs: '',
    progress: 'unknown',
    receptor: { userID: '', userName: '', userImage: userProfileBroken },
    candidates: null,
    paid: null,
    paidPartial: null,
    paidPartialValue: 0,
    start_location: null,
    end_location: null,
    pause: null,
  }

  if (shift)
  {
    const owner = await apiGetUserDetails(shift.owner)
    const creator = await apiGetUserDetails(shift.creator)
    const receptor = String(shift.uid_pegando).trim().length > 0 ? await apiGetUserDetails(shift.uid_pegando) : false

    details = {
      status: shift.status, // ABERTO (disponível), CANCELADO, FECHADO (assumido)
      creator: {
        userID: shift.creator,
        userName: creator.nome || 'ERRO',
        userImage: creator.img || userProfileBroken,
      },
      owner: {
        userID: shift.owner,
        userName: owner.nome || 'ERRO',
        userImage: owner.img || userProfileBroken,
      },
      value: shift.value,
      obs: shift.obs,
      progress: shift.progress,
      receptor: {
        userID: String(shift.uid_pegando).trim(),
        userName: receptor.nome || 'ERRO',
        userImage: receptor.img || userProfileBroken,
      },
      start_location: shift.start_location || null,
      end_location: shift.end_location || null,
      pause: shift.pause || null,
      candidates: Object.prototype.hasOwnProperty.call(shift, 'candidates') ? shift.candidates : null,
      paid: Object.prototype.hasOwnProperty.call(shift, 'paid') ? shift.paid : null,
      paidPartial: Object.prototype.hasOwnProperty.call(shift, 'paid_partial') ? shift.paid_partial : null,
      paidPartialValue: Object.prototype.hasOwnProperty.call(shift, 'paid_partial_value') ? shift.paid_partial_value : null,
    }
  }

  return details
}

const getOldHistoryDetails = async (shift, operation = null) =>
{
  const details = {
    status: '', // 'unknown', // ABERTO (disponível), CANCELADO, FECHADO (assumido)
    creator: null, // { userID: '', userName: '', userImage: userProfileBroken },
    owner: null, // { userID: '', userName: '', userImage: userProfileBroken },
  }

  if (shift)
  {
    // STATUS
    if ('status' in shift) {
      details.status = shift.status
    }

    // CRIADOR
    if (operation && ('uid' in shift)) {
      const creator = await apiGetUserDetails(shift.uid)
      details.creator = {
        userID: shift.uid || '',
        userName: creator.nome || 'ERRO',
        userImage: creator.img || userProfileBroken,
      }
    }

    // PLANTONISTA
    const isUserDuty = ('uid_pegou' in shift) && shift.uid_pegou !== 0 && shift.uid_pegou !== '0'
    if (isUserDuty) {
      const owner = await apiGetUserDetails(shift.uid_pegou)
      details.owner = {
        userID: shift.uid_pegou,
        userName: owner.nome || 'ERRO',
        userImage: owner.img || userProfileBroken,
      }
    }
  }

  return details
}

//
//
//

const isDateTime = value => /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(value)

// /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4} (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/

//
//
//

export default {
  name: 'DetalhesDoPlantao',

  components: {
    'group-tab': GroupTab,
    'app-money-light': AppMoneyLight,
    'sos-button': SosButton,
    'sos-checkbox': SosCheckbox,

    'confirm-dialog': ConfirmDialog,
    'split-shift': SplitShift,

    'date-picker': DatePicker,
  },

  mixins: [
    confirmDialogMixin,
  ],

  props: {
    groupUsers: {
      type: Array,
      default: () => null,
    },
    isPublic: {
      type: Boolean,
      default: () => false,
    },
    shareDetails: {
      type: Object,
      default: () => null
    },
  },

  data () {
    return {
      //
      //
      //

      dutyID: null,

      firstDate: null,
      lastDate: null,

      duty: null,

      // Violações de carga horária do plantão (calculadas no card pai e passadas via open())
      dutyViolations: [],

      //
      //
      //

      groupTab: 'summary',
      groupChildTab: 'ponto',

      canSplit: false,

      // USUÁRIOS INTERESSADOS NO PLANTÃO
      sortBy: [{ key: 'applicationTime', order: 'desc' }],
      candidates: [],

      // STATUS DO DIALOG
      isDialogVisible: false,

      // STATUS DAS OPERAÇÕES EM RELAÇÃO AO DIALOG (ou o contrário)
      isEditing: false,
      isLoading: true,

      // ?
      isExpired: false,
      isExpiredForReiciving: false,

      // ?
      isUserPassingThisShift: false,
      receivingProfile: { image: userProfileBroken, nome: 'Nenhum' },

      // ?
      isAvailable: true,
      isOwned: false,
      isCancelled: false,

      // INICIAR E ENCERRAR
      dutyProgressStatus: 'unknown',

      // Dados do plantão
      groupID: null,
      scaleID: null,
      waitingDutyID: null,
      plantonistaID: null,
      receptorID: null,
      plantaoDataInicio: null,
      plantaoHoraInicio: null,
      isNewTZ: true,
      plantaoObservacao: null,
      shiftExecutionObservation: '',
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      shiftConsultationTime: '',
      dutySlotType: '',
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      dutyLocation: '',
      dutyScaleName: '',

      //
      // INFORMAÇÃO VISÍVEL NA TELA
      //

      // Nome / Escala
      plantaoEscalaNome: null,

      // Status
      dutyStatus: 'Carregando...',
      dutyStatusImage: userProfileBroken,
      MANAGER_ORIGIN_KEY: 'GESTOR',

      // Plantonista
      usuarioPlantonista: { uid: '', image: userProfileBroken, nome: 'Nenhum', groupUser: 'WAITING' },
      campoPlantonistaSelecionado: '0',
      campoPlantonistaOpcoes: [],

      // Valor
      campoValor: 0, // 'R$ 0,00',
      plantaoValor: 0,

      // Observação
      campoObservacao: '',

      // Pagamento realizado?
      fieldPaymentStatus: 'NO',
      dutyPaymentStatus: 'NO',

      // Pagamento parcial?
      fieldPaidPartialValue: 0, // Valor campo mutável
      dutyPaidPartialValue: 0, // Valor campo atual

      // Pagamento realizado? (OPÇÕES)
      paymentStatuses: [
        { image: userProfileBroken, text: 'Não', value: 'NO', disabled: false, divider: false },
        { image: userProfileBroken, text: 'Sim (Completo)', value: 'FULL', disabled: false, divider: false },
        { image: userProfileBroken, text: 'Sim (Parcial)', value: 'PARTIAL', disabled: false, divider: false },
      ],

      // Campo de busca para usuários
      searchUserText: '',
      searchUserInputRef: null,
      plantonistaSelectRef: null,
      isPlantonistaMenuOpen: false, // Usado para detectar quando o menu do v-select do campo plantonista fecha
      plantonistaMenuInterval: null, // Interval para detectar o estado do menu

      // [Tempo estimado] Início
      shiftDateTime: '',
      shiftDateJsObject: null,
      shiftDateTimeJsObject: null,

      // [Tempo estimado] Duração
      plantaoDuracao: null,

      // USADO NA JANELA "DIVIDIR PLANTÃO"
      shiftDuration: '',

      // [Executado pelo plantonista] Início (Quando o plantonista iniciou)
      ownerStartTime: '',
      ownerStartTimeObj: null,

      // Usado apenas para limitar o FIM de um plantão que já foi iniciado...
      ownerStartDateJsObject: null,
      ownerStartDateTimeJsObject: null,

      // [Executado pelo plantonista] Fim (Quando o plantonista encerrou)
      ownerEndTime: '',

      // [Executado pelo plantonista] Pausa (Quando o plantonista pausou e voltou da pausa)
      ownerPauseStartTime: '',
      ownerPauseEndTime: '',
      ownerPauseDuration: '',

      lastShiftBreak: { status: 'waiting', output: '' },

      // [Executado pelo plantonista] Duração (Duração REAL do plantão)
      workedTime: '',

      //
      // [Executado pelo plantonista] Selecionado
      //

      startDateAndTime: '',
      endDateAndTime: '',
      pauseStartDateAndTime: '',
      pauseEndDateAndTime: '',

      //
      //
      //

      // customExecutionTimeDefaultDate: new Date(),
      customStartEndStatus: 'waiting',
      customPauseStatus: 'waiting',

      //
      // LOGS
      //

      candidatesHeader,

      logsLoading: true,
      headers,
      footerProps,
      logs: [],
      fbLogs: [],

      lang: dateTimeLanguage,
    }
  },

  computed: {
    ...mapState({
      userSession: state => state.app.userSession,
      listeners: state => state.app.listeners,
      groupScales: state => state.app.groupScales,
      currentGroupCapabilities: state => state.app.currentGroupCapabilities,
    }),

    shiftBalanceRaw() {
      return getShiftBalance(
        this.duty,
        this.isNewTZ,
        this.plantaoDataInicio,
        this.plantaoHoraInicio,
        this.plantaoDuracao
      )
    },

    balanceFormatted() {
      const totalMinutes = this.shiftBalanceRaw;
      if (totalMinutes === 0 && !this.duty?.end_location?.timestamp) return '';

      const absMinutes = Math.abs(totalMinutes);
      const hours = Math.floor(absMinutes / 60);
      const minutes = absMinutes % 60;

      const sign = totalMinutes >= 0 ? '+' : '-';
      return `${sign}${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },

    balanceClass() {
      const { shiftBalanceRaw } = this;
      const statusClass = shiftBalanceRaw > 0 ? 'text-success-weight' : (shiftBalanceRaw < 0 ? 'text-danger-weight' : '');

      return `dutyDetailText ${statusClass}`.trim();
    },

    checkinLocationText() {
      const loc = this.duty.start_location;
      if (loc && loc.origin !== this.MANAGER_ORIGIN_KEY && (loc.latitude || loc.longitude)) {
        const lat = loc.latitude.toFixed(6);
        const lng = loc.longitude.toFixed(6);
        return `${lat}, ${lng}`;
      }
      return '';
    },

    checkinMapsLink() {
      const text = this.checkinLocationText;
      if (text) {
        return `https://www.google.com/maps/search/?api=1&query=${text}`;
      }
      return '#';
    },

    checkoutLocationText() {
      const loc = this.duty.end_location;
      if (loc && loc.origin !== this.MANAGER_ORIGIN_KEY && (loc.latitude || loc.longitude)) {
        const lat = loc.latitude.toFixed(6);
        const lng = loc.longitude.toFixed(6);
        return `${lat}, ${lng}`;
      }
      return '';
    },

    checkoutMapsLink() {
      const text = this.checkoutLocationText;
      if (text) {
        return `https://www.google.com/maps/search/?api=1&query=${text}`;
      }
      return '#';
    },

    isManagerCheckin() {
      return this.duty.start_location?.origin === this.MANAGER_ORIGIN_KEY;
    },

    isManagerCheckout() {
      return this.duty.end_location?.origin === this.MANAGER_ORIGIN_KEY;
    },

    isCheckoutCopiedFromCheckin() {
      return this.duty.end_location?.copied_from_checkin === true;
    },

    checkinLocationText() {
      const loc = this.duty.start_location;
      if (loc && loc.origin !== this.MANAGER_ORIGIN_KEY && (loc.latitude || loc.longitude)) {
        const lat = loc.latitude.toFixed(6);
        const lng = loc.longitude.toFixed(6);
        return `${lat}, ${lng}`;
      }
      return '';
    },

    checkinMapsLink() {
      const text = this.checkinLocationText;
      if (text) {
        return `https://www.google.com/maps/search/?api=1&query=${text}`;
      }
      return '#';
    },

    checkoutLocationText() {
      const loc = this.duty.end_location;
      if (loc && (loc.origin !== this.MANAGER_ORIGIN_KEY || loc.copied_from_checkin === true) && (loc.latitude || loc.longitude)) {
        const lat = loc.latitude.toFixed(6);
        const lng = loc.longitude.toFixed(6);
        return `${lat}, ${lng}`;
      }
      return '';
    },

    checkoutMapsLink() {
      const text = this.checkoutLocationText;
      if (text) {
        return `https://www.google.com/maps/search/?api=1&query=${text}`;
      }
      return '#';
    },

    isManagerCheckin() {
      return this.duty.start_location?.origin === this.MANAGER_ORIGIN_KEY;
    },

    isManagerCheckout() {
      return this.duty.end_location?.origin === this.MANAGER_ORIGIN_KEY;
    },

    isCheckoutCopiedFromCheckin() {
      return this.duty.end_location?.copied_from_checkin === true;
    },

    ownerEndDateJsObject() {
      if (!this.ownerEndTime) {
          return null;
      }

      const formattedDate = this.ownerEndTime.replace(' às ', ' ');

      const dateObject = moment(formattedDate, 'DD/MM/YYYY HH:mm:ss');


      if (dateObject.isValid()) {
          return dateObject.toDate();
      }

      return null;
    },

    processedGroupScales () {
      // return !!this.listeners === true && !!this.listeners.groupScales === true && Array.isArray(this.listeners.groupScales) && this.listeners.groupScales.length > 0 ? this.listeners.groupScales : []
      // return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0
      return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
    },

    observation: function () {
      const nl2br = str => !!str === true ? (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2') : ''
      return nl2br(this.campoObservacao.trim())
    },

    value: function () {
      return formatMoney(this.plantaoValor || 0)
    },

    partialPaymentValue: function () {
      return formatMoney(this.fieldPaidPartialValue || 0)
    },

    //
    // PERMISSIONS
    //

    /* permissaoSalvar() {
      if (this.currentGroupCapabilities) {
        return this.currentGroupCapabilities[DETALHES_PLANTAO_APAGAR] ||
          this.currentGroupCapabilities[DETALHES_PLANTAO_DIVIDIR] ||
          this.currentGroupCapabilities[DETALHES_PLANTAO_ALTERAR]
      }
    }, */

    permissaoDetalhesPlantaoApagar () {
      return this.currentGroupCapabilities ? this.currentGroupCapabilities[DETALHES_PLANTAO_APAGAR] : false
    },

    permissaoDetalhesPlantaoDividir () {
      return this.currentGroupCapabilities ? this.currentGroupCapabilities[DETALHES_PLANTAO_DIVIDIR] : false
    },

    permissaoDetalhesPlantaoAlterar () {
      return this.currentGroupCapabilities ? this.currentGroupCapabilities[DETALHES_PLANTAO_ALTERAR] : false
    },

    permissaoDetalhesPlantaoPersonalizarRegistro () {
      return this.currentGroupCapabilities ? this.currentGroupCapabilities[DETALHES_PLANTAO_PERSONALIZAR_REGISTRO] : false
    },

    permissaoVerValores () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_VER_VALORES] === true
    },

    // Título do header
    headerTitleDate () {
      return `${moment(this.plantaoDataInicio).utc().format('DD/MM/YY')} às ${this.plantaoHoraInicio} - ${this.plantaoDuracao}`
    },

    // Séries
    isVacationType() {
      return (this.duty?.type || '') === SERIES_VACATION;
    },
    isDayOffType() {
      return (this.duty?.type || '') === SERIES_DAY_OFF;
    },
    /* seriesType() {
      return getSeriesTypeLabel(this.duty?.type || '').toUpperCase()
    }, */

    // Usuários filtrados para o select
    filteredUserOptions() {
      if (!this.searchUserText || this.searchUserText.trim() === '') {
        return this.campoPlantonistaOpcoes;
      }

      const searchTerm = this.searchUserText.toLowerCase().trim();
      const filteredUsers = this.campoPlantonistaOpcoes.filter(user =>
        user.text.toLowerCase().includes(searchTerm) ||
        user.value.toLowerCase().includes(searchTerm)
      );

      return filteredUsers;
    },

    permissaoVerValores () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_VER_VALORES] === true
    },
  },

  watch: {
    isEditing: {
      handler (newIsEditing, oldIsEditing) {
        console.log('🔍 isEditing:', newIsEditing)

        if (newIsEditing) this.startPlantonistaMenuDetection()
        if (!newIsEditing) this.stopPlantonistaMenuDetection()
      },
      immediate: true,
    },

    //
    //
    //

    isDialogVisible: {
      handler (newDialogStatus, oldDialogStatus) {
        if (!newDialogStatus) this.clear()
      },
      // the callback will be called immediately after the start of the observation
      immediate: true,
    },

    //
    // CLEAR END DATE AND TIME IF THE USER SELECTED A HIGHER START DATE AND TIME
    //

    startDateAndTime: {
      handler (newStartTime, oldStartTime)
      {
        if (newStartTime !== oldStartTime && newStartTime.length > 0 && this.endDateAndTime.length > 0)
        {
          const startTimestamp = moment(newStartTime, 'DD/MM/YYYY HH:mm:ss').valueOf()
          const endTimestamp = moment(this.endDateAndTime, 'DD/MM/YYYY HH:mm:ss').valueOf()

          if (startTimestamp > endTimestamp) this.endDateAndTime = ''
        }
      },
      // the callback will be called immediately after the start of the observation
      immediate: true,
    },

    //
    // CLEAR THE PARTIAL VALUE IF THE MANAGER FORGOTO TO CLEAN IT
    //

    fieldPaymentStatus: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (newPaymentStatus, oldPaymentStatus)
      {
        // Zera o valor caso o usuário selecione uma opção diferente de "Sim (Parcial)" e esqueça de zerar
        if (newPaymentStatus !== 'PARTIAL') this.fieldPaidPartialValue = 0
        // Restaura o valor do pagamento parcial caso o usuário selecione uma opção diferente de "Sim (Parcial)" e depois selecione "Sim (Parcial)" novamente
        if (newPaymentStatus === 'PARTIAL') this.fieldPaidPartialValue = this.dutyPaidPartialValue
      },
    },

    // Manter seleção quando clicar fora do input de busca
    searchUserText: {
      handler (newSearchText, oldSearchText) {
        // Se o campo de busca foi limpo e não há usuário selecionado, mantém "Nenhum"
        if (!newSearchText && !this.campoPlantonistaSelecionado) {
          this.campoPlantonistaSelecionado = '0';
        }
      },
    },

    // Detectar quando o menu do v-select fecha
    isPlantonistaMenuOpen: {
      handler (isOpen, wasOpen) {
        // Se o menu estava aberto e agora fechou
        if (wasOpen && !isOpen) {
          this.onPlantonistaBlur();
        }
      },
    },
  },

  beforeDestroy() {
    // Para a detecção do menu do v-select
    this.stopPlantonistaMenuDetection();
  },

  methods: {

    calculateEndTimeFromDuration() {
      if (!this.ownerStartTimeObj || !this.duty?.periodo) {
        return '';
      }

      const durationMinutes = this.duty.periodo;

      let endTimeMoment = this.ownerStartTimeObj.clone();

      endTimeMoment.add(durationMinutes, 'minutes');

      return endTimeMoment.format('DD/MM/YYYY HH:mm');
    },
    //
    //
    //
    // Carrega detalhes do plantão
    //
    // NOTA:
    // Otimizar mais ainda, dependendo apenas do this.duty
    //
    //
    //

    async loadDuty ()
    {
      this.duty = await getDutyByID(this.dutyID)

      // Debug
      //console.log('::: [DEBUG] DUTY ID:', this.dutyID, this.duty)
      // [24/01/25] console.log('::: DETALHES DO PLANTÃO:', this.dutyID, this.duty)

      // Sinaliza carregamento para o dialog
      this.isLoading = true

      // Fecha MODO DE EDIÇÃO para o TEMPO DE EXECUÇÃO personalizado
      this.stopEditingCustomExecutionTime()

      // CARREGA OS USUÁRIOS INTERESSADOS NO PLANTÃO
      await this.setDutyCandidates(this.duty)

      //
      // DADOS DO PLANTÃO
      //

      this.dutyLocation = !!this.duty.local && !!this.duty.local.nome ? String(this.duty.local.nome).trim() : ''
      this.dutyScaleName = !!this.duty.nome === true ? String(this.duty.nome).trim() : '' // Nome da escala do plantão?

      const plantaoStatus = String(this.duty.status || 'aberto') // Nota: Continuar tratando inexistencia como DISPONÍVEL?

      this.groupID = this.duty.groupID || '' // Nota: Usado apenas para apagar o plantão
      this.scaleID = this.duty.scaleID || '' // Nota: Usado apenas para DIVIDIR E APAGAR O PLANTÃO (Componente "split-shift")
      this.waitingDutyID = this.duty.waitingDutyID || '' // Nota: Usado apenas para apagar o plantão (ou dividir e apagar o plantão)
      this.plantonistaID = String(this.duty.uid_pegou || 0) // Nota: Continuar tratando inexistencia como DISPONÍVEL?
      this.receptorID = String(this.duty.uid_pegando || '')

      this.plantaoDataInicio = this.duty.data_inicio
      this.plantaoHoraInicio = this.duty.hora_inicio // JESUS: Impedir hora_inicio com um 1 ou 2 de tamanho, pois pode gerar bug ao limitar seletor de data/horário (registro personalizado de execução do plantão)
      this.isNewTZ = this.duty.dutyStartDateTZ && this.duty.dutyStartDateTZ === '+0000'

      this.plantaoDuracao = formatDuration(valueToTime(this.duty.periodo || 0), false) // Nota: Usado apenas para exibição
      this.plantaoObservacao = this.duty.observacao || '' // Nota: Usado apenas para recuperar o valor quando o UPDATE falhar
      this.plantaoEscalaNome = this.duty.nome || ''

      const dutyValue = this.duty.valor || 0
      this.campoValor = dutyValue
      this.plantaoValor = dutyValue

      //
      // STATUS DO PAGAMENTO
      // PARCIAL, SIM (TOTAL) ou NÃO
      //

      const paid = this.duty.paid || false
      const paidPartial = this.duty.paid_partial || false
      const paidPartialValue = this.duty.paid_partial_value || 0

      this.fieldPaymentStatus = paidPartial === true ? 'PARTIAL' : (paid === true ? 'FULL' : 'NO')
      this.dutyPaymentStatus = paidPartial === true ? 'PARTIAL' : (paid === true ? 'FULL' : 'NO')

      this.fieldPaidPartialValue = paidPartialValue
      this.dutyPaidPartialValue = paidPartialValue

      //
      // USADO NA JANELA "DIVIDIR PLANTÃO"
      //

      this.shiftDuration = valueToTime(this.duty.periodo || 0)

      //
      // ?

      this.campoObservacao = this.plantaoObservacao

      //
      // PROGRESSO

      this.dutyProgressStatus = this.duty.start_location && this.duty.end_location ? 'finished' : (this.duty.start_location ? 'started' : 'unknown')

      //
      // STATUS

      this.isAvailable = this.plantonistaID === '0' && plantaoStatus === 'aberto'
      this.isOwned = this.plantonistaID !== '0' && plantaoStatus === 'fechado'
      this.isCancelled = plantaoStatus === 'cancelado'

      //
      // USADO NA JANELA "DIVIDIR PLANTÃO"
      //

      this.canSplit = durationIsTwoHoursOrMore(this.shiftDuration) && !this.isCancelled && !this.isAvailable

      //
      // DATA E HORA DE INÍCIO DO PLANTÃO

      const dutyStartDate = this.isNewTZ ? moment.utc(this.plantaoDataInicio) : moment(this.plantaoDataInicio)
      this.shiftDateTime = `${dutyStartDate.format('DD/MM/YYYY')} ${this.plantaoHoraInicio}`

      //
      //

      this.shiftDateJsObject = new Date(dutyStartDate.format('YYYY-MM-DD') + 'T00:00:00')
      this.shiftDateTimeJsObject = new Date(dutyStartDate.format('YYYY-MM-DD') + 'T' + this.plantaoHoraInicio + ':00')

      // customExecutionTimeDefaultDate: new Date(),

      //
      // IS EXPIRED

      this.isExpired = isShiftExpiredNew(this.plantaoDataInicio, this.plantaoHoraInicio, this.isNewTZ, this.dutyProgressStatus, 15)
      this.isExpiredForReiciving = isShiftExpiredNew(this.plantaoDataInicio, this.plantaoHoraInicio, this.isNewTZ, this.dutyProgressStatus)

      //
      // Plantonista está passando o plantão para alguém?

      this.isUserPassingThisShift = !!this.receptorID && /(([A-Za-z0-9\-_]){10,256})+/.test(this.receptorID) && !this.isExpiredForReiciving

      if (this.isUserPassingThisShift)
      {
        const receivingProfile = await apiGetUserDetails(this.receptorID)

        // Plantonista identificado
        this.receivingProfile = { image: receivingProfile.img || userProfileBroken, nome: receivingProfile.nome || 'Erro' }
      }

      //
      //
      //
      // RECONHECE O PLANTONISTA RESPONSÁVEL POR ESSE PLANTÃO (SE HOUVER)
      // DEFINE OPÇÕES NO SELETOR DE PLANTONISTAS
      // DEFINE A OPÇÃO SELECIONADA
      //
      //
      //

      // ESCALAS DE CADA USUÁRIO DO GRUPO
      const usersScales = Object.fromEntries(
        this.groupUsers.map(gu => ([
          gu.userID,
          // JESUS: Testar sem if (this.processedGroupScales.length > 0)
          this.processedGroupScales.filter(gs => gs.scaleRelatedUsers.some(userID => userID === gu.userID)).map(gs => gs.scaleID),
        ]))
      )

      // USUÁRIOS SELECIONÁVEIS, MAS APENAS AQUELES QUE PODEM VER A ESCALA DO PLANTÃO A SER DIVIDIDO, OU SEJA, USUÁRIOS QUE NÃO TEM ESCALA RELACIONADA OU USUÁRIOS QUE TEM ESSA ESCALA SELECIONADA
      const users = this.groupUsers.filter(gu => (
        (
          // Usuário não encontrado
          !!usersScales[gu.userID] === false
        ) ||
        (
          // Usuário encontrado + Relacionado a todas as escalas (Nota: Segundo a regra de negócio = Nenhuma escala relacionada)
          !!usersScales[gu.userID] === true &&
          usersScales[gu.userID].length === 0
        ) ||
        (
          // Usuário encontrado + Relacionado a escala do plantão a ser dividido
          !!usersScales[gu.userID] === true &&
          usersScales[gu.userID].length > 0 &&
          usersScales[gu.userID].some(scaleID => scaleID === this.scaleID)
        )
      ))

      //
      // Define opções
      //

      this.campoPlantonistaOpcoes = [
        // disponivelOuVencido
        { image: userProfileBroken, text: 'Nenhum', value: '0', disabled: false, divider: false },
        // USUÁRIOS
        ...users.map(user => ({ image: user.userImage, text: user.userName, value: String(user.userID), disabled: false, divider: false })),
      ]

      // console.log('::: DUTY DETAILS > LOAD DUTY > usersScales:', usersScales)
      // console.log('::: DUTY DETAILS > LOAD DUTY > groupUsers:', this.groupUsers)
      // console.log('::: DUTY DETAILS > LOAD DUTY > processedGroupScales:', this.processedGroupScales)
      // [24/01/25] console.log('::: DUTY DETAILS > LOAD DUTY > users:', users)
      // [24/01/25] console.log('::: DUTY DETAILS > LOAD DUTY > campoPlantonistaOpcoes:', this.campoPlantonistaOpcoes)

      //
      // PLANTONISTA RESPONSÁVEL PELO PLANTÃO
      //

      this.usuarioPlantonista = { uid: '', image: userProfileBroken, nome: 'Nenhum', groupUser: 'WAITING' }

      if (this.isOwned)
      {
        // Busca plantonista nos usuários do grupo
        const foundDoctorInGroup = this.groupUsers.find(user => user.userID === this.plantonistaID)

        // Se não encontrou o plantonista no grupo, houve um bug ou ele saiu do grupo
        if (!!foundDoctorInGroup === false)
        {
          const owner = await apiGetUserDetails(this.plantonistaID)

          // Plantonista identificado
          this.usuarioPlantonista = { uid: this.plantonistaID, image: owner.img || userProfileBroken, nome: owner.nome || 'Erro', groupUser: 'NO' }
        }
        else
        {
          this.usuarioPlantonista = { uid: this.plantonistaID, image: foundDoctorInGroup.userImage, nome: foundDoctorInGroup.userName, groupUser: 'YES' }
        }
      }

      // [24/01/25] console.log('::: DUTY DETAILS > LOAD DUTY > usuarioPlantonista:', this.usuarioPlantonista)

      //
      // Define opção selecionada
      //

      if (this.isAvailable)
      {
        // console.log(`::: OPÇÃO PADRÃO NO SELETOR DE PLANTONISTAS > "${this.plantonistaID}": Disponível`)

        this.campoPlantonistaSelecionado = '0'
      }
      else
      {
        // console.log(`::: OPÇÃO PADRÃO NO SELETOR DE PLANTONISTAS > "${this.plantonistaID}"`)

        this.campoPlantonistaSelecionado = this.usuarioPlantonista.uid
        // this.campoPlantonistaSelecionado = this.usuarioPlantonista.uid || '0'

        //
        // Inclui o plantonista (desativado) como opção caso:
        // + Ele não esteja relacionado a escala
        // + Ou não faça mais parte do grupo
        // + Ou algum outro cenário (talvez bug?)
        //

        if (this.campoPlantonistaOpcoes.some(opt => String(opt.value) === String(this.plantonistaID)) === false) {
          const userNotRelatedToScale = users.some(chkuser => chkuser.userID === this.usuarioPlantonista.uid) === false
          const userHasLeftThisGroup = this.usuarioPlantonista.groupUser !== 'YES'
          const disabled = userNotRelatedToScale || userHasLeftThisGroup
          const disabledReason = userNotRelatedToScale ? 'Não vinculado a escala' : (userHasLeftThisGroup ? 'Saiu do grupo' : '')
          this.campoPlantonistaOpcoes.push({ image: this.usuarioPlantonista.image, text: `<span class="consultationName">${this.usuarioPlantonista.nome}</span>${!!disabledReason === true ? ` <span class="consultationNotice consultationNotice--manager">${disabledReason}</span>` : ''}`, value: String(this.usuarioPlantonista.uid), disabled, divider: false })
        }
      }

      //
      //
      //
      // APONTAMENTOS REAIS (INÍCIO, PAUSA, RETOMADA, FIM E DURAÇÃO)
      //
      //
      //

      // INÍCIO REAL
      const m1 = this.duty.start_location?.timestamp ? ((this.duty.start_location?.tz || '') === 'UTC' ? moment.utc : moment)(this.duty.start_location.timestamp) : null
      const m1copy = !!m1 === true ? m1.clone() : null
      this.ownerStartTimeObj = !!m1copy === true ? m1copy : null
      this.ownerStartTime = !!m1copy === true ? m1copy.format('DD/MM/YYYY [às] HH:mm:ss') : ''

      // Usado apenas para limitar o FIM de um plantão que já foi iniciado...
      this.ownerStartDateJsObject = !!m1copy === true ? new Date(m1copy.format('YYYY-MM-DD') + 'T00:00:00') : null // JESUS: Testar
      this.ownerStartDateTimeJsObject = !!m1copy === true ? new Date(m1copy.format('YYYY-MM-DD') + 'T' + m1copy.format('HH:mm:ss')) : null // JESUS: Testar

      // PAUSA REAL

      // this.group.allowPauseDuringShift

      // STATUS DA PAUSA (SE HOUVER)
      this.lastShiftBreak = getShiftPause(this.duty)

      this.ownerPauseStartTime = this.lastShiftBreak.status === 'started' || this.lastShiftBreak.status === 'finished' ? `${this.lastShiftBreak.output.startDate} às ${this.lastShiftBreak.output.startTime}` : ''
      this.ownerPauseEndTime = this.lastShiftBreak.status === 'started' ? 'Pausa em andamento...' : (this.lastShiftBreak.status === 'finished' ? `${this.lastShiftBreak.output.endDate} às ${this.lastShiftBreak.output.endTime}` : '')
      this.ownerPauseDuration = this.lastShiftBreak.status === 'finished' ? this.lastShiftBreak.output.duration : ''

      // FIM REAL
      const m2 = this.duty.end_location?.timestamp ? ((this.duty.end_location?.tz || '') === 'UTC' ? moment.utc : moment)(this.duty.end_location.timestamp) : null
      this.ownerEndTime = !!m2 === true ? m2.clone().format('DD/MM/YYYY [às] HH:mm:ss') : ''

      // DURAÇÃO REAL

      this.workedTime = '' // Jesus: Testar

      if (!!m1 && !!m2)
      {
        var duration = m2.diff(m1, 'minutes')
        var numdays = Math.floor(duration / 1440)
        var numhours = Math.floor((duration % 1440) / 60)
        var numminutes = Math.floor((duration % 1440) % 60)
        this.workedTime = (numdays > 0 ? `${numdays} dia${numdays === 1 ? '' : 's'} ` : '') +
                          (numhours > 0 ? `${numhours} hora${numhours === 1 ? '' : 's'} ` : '') +
                          (numminutes > 0 ? `${numminutes} minuto${numminutes === 1 ? '' : 's'}` : 'menos de um minuto')
      }

      // OBSERVAÇÃO
      this.shiftExecutionObservation = !!this.duty.end_location === true && !!this.duty.end_location.observation === true ? String(this.duty.end_location.observation).trim() : (
        !!this.duty.end_observation_backup === true ? String(this.duty.end_observation_backup).trim() : ''
      )

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      // DURAÇÃO DA CONSULTA
      this.shiftConsultationTime = !!this.duty.tempo_consulta === true && parseInt(this.duty.tempo_consulta) > 0 ? `${this.duty.tempo_consulta} minutos` : 'Desativado'

      // TIPO DE CONSULTA
      this.dutySlotType = (this.duty.slotType || "") === "FOLLOW_UP" ? "Retorno" : (
        (this.duty.slotType || "") === "FIRST_APPOINTMENT" ? "Primeira consulta" : "Livre"
      )
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      // STATUS
      this.setShiftStatus()

      // GET LOGS
      if (!this.isPublic)
      {
        const logs = await apiGetShiftHistory(this.dutyID)
        this.fbLogs = logs.length > 0 ? logs : []
        this.logs = logs.length > 0 ? await this.processarHistorico(logs) : []
        this.logsLoading = false
        // console.log('logs:', this.fbLogs);
      }

      // AVISA A UI QUE TERMINOU DE CARREGAR OS DETALHES DO PLANTÃO
      this.isLoading = false
    },

    //
    //
    //
    // Abrir janela
    //
    //
    //

    async open (dutyID, firstDate, lastDate, violations)
    {
      // Abre o dialog
      this.isDialogVisible = true

      // ID do plantão
      this.dutyID = dutyID

      // Violações de carga horária calculadas no card pai (exibe banner no Resumo)
      this.dutyViolations = Array.isArray(violations) ? violations : []

      // Período selecionado na tela que invocou essa janela
      this.firstDate = firstDate
      this.lastDate = lastDate

      // Carrega detalhes do plantão
      await this.loadDuty()
    },

    //
    //
    //
    // Fechar janela
    //
    //
    //

    closeDialog ()
    {
      if (this.isLoading) return

      this.isDialogVisible = false
    },

    //
    //
    //
    // Limpeza do state do componente
    //
    //
    //

    clear ()
    {
      //
      //
      //

      this.dutyID = null

      this.firstDate = null
      this.lastDate = null

      this.duty = null

      this.dutyViolations = []

      this.searchUserText = '' // Limpa o campo de busca


      //
      //
      //

      // CAIXA DE MENSAGEM
      this.cdParameters = {
        title: '',
        text: '',
        buttonPosition: 'right',
        width: 330,
      }

      // STATUS DO DIALOG
      // this.isDialogVisible = false

      // STATUS DAS OPERAÇÕES EM RELAÇÃO AO DIALOG (ou o contrário)
      this.isEditing = false
      this.isLoading = true

      // ?
      this.groupTab = 'summary'
      this.groupChildTab = 'ponto'

      // ?
      this.canSplit = false

      // ?
      this.isExpired = false
      this.isExpiredForReiciving = false

      // ?
      this.isUserPassingThisShift = false
      this.receivingProfile = { image: userProfileBroken, nome: 'Nenhum' }

      // ?
      this.isAvailable = true
      this.isOwned = false
      this.isCancelled = false

      // INICIAR E ENCERRAR
      this.dutyProgressStatus = 'unknown'

      // USUÁRIOS INTERESSADOS NO PLANTÃO
      this.candidates = []

      // Dados do plantão
      this.groupID = null
      this.scaleID = null
      this.waitingDutyID = null
      this.plantonistaID = null
      this.receptorID = null
      this.plantaoDataInicio = null
      this.plantaoHoraInicio = null
      this.isNewTZ = true
      this.plantaoObservacao = null
      this.shiftExecutionObservation = ''
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      this.shiftConsultationTime = ''
      this.dutySlotType = ''
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      this.dutyLocation = ''
      this.dutyScaleName = ''

      //
      // INFORMAÇÃO VISÍVEL NA TELA
      //

      // Nome / Escala
      this.plantaoEscalaNome = null

      // Status
      this.dutyStatus = 'Carregando...'
      this.dutyStatusImage = userProfileBroken

      // Plantonista
      this.usuarioPlantonista = { uid: '', image: userProfileBroken, nome: 'Nenhum', groupUser: 'WAITING' }
      this.campoPlantonistaSelecionado = '0'
      this.campoPlantonistaOpcoes = []

      // Valor
      this.campoValor = 0 // 'R$ 0,00'
      this.plantaoValor = 0

      // Observação
      this.campoObservacao = ''

      // Pagamento realizado?
      this.fieldPaymentStatus = 'NO'
      this.dutyPaymentStatus = 'NO'

      // Pagamento parcial?
      this.fieldPaidPartialValue = 0 // 'R$ 0,00'
      this.dutyPaidPartialValue = 0

      // [Tempo estimado] Início
      this.shiftDateTime = ''
      this.shiftDateJsObject = null
      this.shiftDateTimeJsObject = null

      // [Tempo estimado] Duração
      this.plantaoDuracao = null

      // USADO NA JANELA "DIVIDIR PLANTÃO"
      this.shiftDuration = ''

      // [Executado pelo plantonista] Início (Quando o plantonista iniciou)
      this.ownerStartTime = ''
      this.ownerStartTimeObj = null

      // Usado apenas para limitar o FIM de um plantão que já foi iniciado...
      this.ownerStartDateJsObject = null
      this.ownerStartDateTimeJsObject = null

      // [Executado pelo plantonista] PAUSOU E RETOMOU
      this.ownerPauseStartTime = ''
      this.ownerPauseEndTime = ''
      this.ownerPauseDuration = ''

      this.lastShiftBreak = { status: 'waiting', output: '' }

      // [Executado pelo plantonista] Fim (Quando o plantonista encerrou)
      this.ownerEndTime = ''

      // [Executado pelo plantonista] Duração (Duração REAL do plantão)
      this.workedTime = ''

      //
      // [Executado pelo plantonista] Selecionado
      //

      this.startDateAndTime = ''
      this.endDateAndTime = ''
      this.pauseStartDateAndTime = ''
      this.pauseEndDateAndTime = ''

      //
      //
      //

      // this.customExecutionTimeDefaultDate = new Date()
      this.customStartEndStatus = 'waiting'
      this.customPauseStatus = 'waiting'

      //
      // LOGS
      //

      this.logsLoading = true
      this.logs = []
    },

    //
    //
    //
    // CONFIRMAÇÃO DE FUNCIONALIDADES
    //
    //
    //


    // CONFIRMAR APAGAR CHECKOUT
    confirmDeleteCheckout () {
      if (this.isLoading) return false
      this.showDialog(
        'Apagar Checkout',
        'Tem certeza que deseja apagar o registro de checkout?<br /><br />O plantão voltará ao status "Em andamento" e o check-in poderá ser editado.',
        'delete-checkout',
        '',
        false,
        'center',
        400
      )
    },

    confirmCopyCheckinToCheckout () {
      if (this.isLoading) return false

      if (!this.duty?.start_location || !this.ownerStartTimeObj) {
        return this.showMessage('Atenção!', 'Não há check-in válido para copiar.')
      }

      this.showDialog(
        'Copiar Check-in',
        'As informações do check-in serão copiadas para o check-out e os dados atuais do check-out serão substituídos.<br /><br /><b>Deseja continuar?</b>',
        'copy-checkin-to-checkout',
        '',
        false,
        'center',
        400
      )
    },

    // APAGAR PLANTÃO
    openConfirmDutyDeletionModal ()
    {
      if (this.isLoading) return false
      this.showDialog('Atenção!', 'O plantão será <b style="color: orangered">apagado permanentemente</b> do sistema e dos relatórios.<br /><br /><b>Deseja continuar?</b>', 'delete-duty', '', false, 'center', 400)
    },

    // ACEITAR CANDIDATO
    confirmAcceptCandidate (candidateId)
    {
      if (this.isLoading || this.isCancelled) return false
      this.showDialog('Atenção!', 'Você está prestes a aceitar o candidato.<br /><br /><b>Deseja continuar?</b>', 'accept-duty-candidate', { candidateId, validateConflicts: true }, false, 'center', 400)
    },

    // RECUSAR CANDIDATO
    confirmRefuseCandidate (candidateId)
    {
      if (this.isLoading || this.isCancelled) return false
      this.showDialog('Atenção!', 'Você está prestes a recusar o candidato.<br /><br /><b>Deseja continuar?</b>', 'refuse-duty-candidate', candidateId, false, 'center', 400)
    },

    // ACEITAR PASSAGEM DO PLANTÃO ENTRE DOIS USUÁRIOS
    confirmShareAccept ()
    {
      if (this.isLoading) return false
      this.showDialog('Atenção!', `O plantão será passado para <span style="color: #4682b4; font-weight: 500">${this.receivingProfile.nome || 'o destinatário'}</span>.<br /><br /><b>Deseja continuar?</b>`, 'accept-duty-sharing', '', false, 'center', 400)
    },

    // CANCELAR PASSAGEM DO PLANTÃO ENTRE DOIS USUÁRIOS
    confirmShareCancel ()
    {
      if (this.isLoading) return false
      this.showDialog('Atenção!', `A passagem do plantão será <b style="color: indianred;">CANCELADA</b> e <span style="color: #4682b4; font-weight: 500">${this.usuarioPlantonista.nome || 'o plantonista'}</span> continuará com ele.<br /><br /><b>Deseja continuar?</b>`, 'cancel-duty-sharing', '', false, 'center', 400)
    },

    startCheckinEditMode() {
      if (this.isLoading) return false;

      if (this.ownerStartTimeObj) {
        this.startDateAndTime = this.ownerStartTimeObj.format('DD/MM/YYYY HH:mm');
      }

      this.customStartEndStatus = 'start';
    },

    // PERSONALIZAR REGISTRO DE INÍCIO DO PLANTÃO
    setStartDateTimeRecord ()
    {
      if (this.isLoading) return false

      if (this.customStartEndStatus === 'waiting') {
        if (this.dutyProgressStatus === 'started' && this.ownerStartTimeObj) {
          this.startDateAndTime = this.ownerStartTimeObj.format('DD/MM/YYYY HH:mm')
        }
        this.customStartEndStatus = 'start'
        return false
      }

      if (!isDateTime(this.startDateAndTime)) {
        return this.showMessage('Aviso!', 'Selecione um início personalizado ou cancele')
      }

      const isAltering = !!this.ownerStartTime

      const actionText = !isAltering
        ? '<b style="color: indianred;">INICIAR</b>'
        : '<b style="color: indianred;">ALTERAR O INÍCIO</b>'

      let dialogMessage = `Você está prestes a ${actionText} o plantão${!!this.usuarioPlantonista.nome === true && this.usuarioPlantonista.nome.length > 0 ? ` de <span style="color: #4682b4; font-weight: 500">${this.usuarioPlantonista.nome}</span>` : ''}.`

      if (isAltering) {
        dialogMessage += '<br /><br /><span style="color: #e54245; font-weight: 500;">Atenção:</span> As informações de GPS originais serão perdidas caso o check-in seja alterado.'
      }

      dialogMessage += '<br /><br /><b>Deseja continuar?</b>'

      this.showDialog('Atenção!', dialogMessage, 'custom-start-shift', '', false, 'center', 400)
    },

    // PERSONALIZAR REGISTRO DE CONCLUSÃO DO PLANTÃO
    setEndDateTimeRecord ()
    {
      if (this.isLoading) return false

      if (this.dutyProgressStatus !== 'started') return false

      if (this.customStartEndStatus === 'waiting') {
          this.customStartEndStatus = 'end'

          if (this.ownerStartTimeObj && this.duty?.periodo) {
            const durationHours = this.duty.periodo;
            const endTimeMoment = this.ownerStartTimeObj.clone().add(durationHours, 'hours');
            this.endDateAndTime = endTimeMoment.format('DD/MM/YYYY HH:mm');
          }

          return false
      }

      if (!isDateTime(this.endDateAndTime)) return this.showMessage('Aviso!', 'Selecione uma data e horário de conclusão personalizados ou cancele')

      this.showDialog('Atenção!', `Você está prestes a <b style="color: indianred;">FINALIZAR</b> o plantão${!!this.usuarioPlantonista.nome === true && this.usuarioPlantonista.nome.length > 0 ? ` de <span style="color: #4682b4; font-weight: 500">${this.usuarioPlantonista.nome}</span>` : ''}.<br /><br /><b>Deseja continuar?</b>`, 'custom-end-shift', '', false, 'center', 400)
    },

    // APAGAR REGISTRO DE INÍCIO E/OU CONCLUSÃO DO PLANTÃO
    undoExecutionTime ()
    {
      this.showDialog('Atenção!', `O registro de check-in/check-out de <span style="color: #4682b4; font-weight: 500">${this.usuarioPlantonista.nome || 'o plantonista'}</span> será <b style="color: indianred;">DESFEITO</b>.<br /><br /><b>Deseja continuar?</b>`, 'undo-shift-execution-time', '', false, 'center', 400)
    },

    //
    //
    //
    // SAI DO MODO DE EDIÇÃO DO "TEMPO DE EXECUÇÃO PERSONALIZADO"
    //
    //
    //

    stopEditingCustomExecutionTime ()
    {
      this.customStartEndStatus = 'waiting'

      this.startDateAndTime = ''
      this.endDateAndTime = ''
    },

    //
    //
    // EDITAR PAUSA DO PLANTÃO
    //
    //
    //
    // INICIA REGISTRO DE PAUSA (quando não existe pausa ainda)
    //
    //

    startPauseRegistration() {
      if (this.isLoading) return false;
      this.pauseStartDateAndTime = '';
      this.customPauseStatus = 'start';
    },

    //
    //
    // INICIA REGISTRO DE RETORNO (quando pausa está em andamento)
    //
    //

    registerPauseReturn() {
      if (this.isLoading) return false;
      this.pauseEndDateAndTime = '';
      this.customPauseStatus = 'end';
    },

    //
    //
    // EDITA INÍCIO DA PAUSA (quando pausa já foi finalizada)
    //
    //

    editPauseStart() {
      if (this.isLoading) return false;

      if (this.lastShiftBreak && this.lastShiftBreak.output) {
        const output = this.lastShiftBreak.output;
        this.pauseStartDateAndTime = `${output.startDate} ${output.startTime}`;
      }

      this.customPauseStatus = 'start';
    },

    //
    //
    // EDITA FIM DA PAUSA (quando pausa já foi finalizada)
    //
    //

    editPauseEnd() {
      if (this.isLoading) return false;

      if (this.lastShiftBreak && this.lastShiftBreak.output) {
        const output = this.lastShiftBreak.output;
        this.pauseEndDateAndTime = `${output.endDate} ${output.endTime}`;
      }

      this.customPauseStatus = 'end';
    },

    // CONFIRMAR REGISTRO/EDIÇÃO DE INÍCIO DA PAUSA
    setPauseStartDateTimeRecord() {
      if (this.isLoading) return false;

      if (!isDateTime(this.pauseStartDateAndTime)) {
        return this.showMessage('Aviso!', 'Selecione um horário de pausa válido ou cancele');
      }

      const isEditing = this.lastShiftBreak.status === 'finished';
      const actionText = isEditing ? '<b style="color: indianred;">ALTERAR O INÍCIO DA PAUSA</b>' : '<b style="color: indianred;">REGISTRAR A PAUSA</b>';
      let dialogMessage = `Você está prestes a ${actionText} do plantão${!!this.usuarioPlantonista.nome === true && this.usuarioPlantonista.nome.length > 0 ? ` de <span style="color: #4682b4; font-weight: 500">${this.usuarioPlantonista.nome}</span>` : ''}.`;
      dialogMessage += '<br /><br /><b>Deseja continuar?</b>';

      this.showDialog('Atenção!', dialogMessage, 'custom-pause-start', '', false, 'center', 400);
    },

    // CONFIRMAR REGISTRO/EDIÇÃO DE FIM DA PAUSA
    setPauseEndDateTimeRecord() {
      if (this.isLoading) return false;

      if (!isDateTime(this.pauseEndDateAndTime)) {
        return this.showMessage('Aviso!', 'Selecione um horário de fim da pausa válido ou cancele');
      }

      const isEditing = this.lastShiftBreak.status === 'finished';
      const actionText = isEditing ? '<b style="color: indianred;">ALTERAR O FIM DA PAUSA</b>' : '<b style="color: indianred;">REGISTRAR O RETORNO</b>';
      let dialogMessage = `Você está prestes a ${actionText} do plantão${!!this.usuarioPlantonista.nome === true && this.usuarioPlantonista.nome.length > 0 ? ` de <span style="color: #4682b4; font-weight: 500">${this.usuarioPlantonista.nome}</span>` : ''}.`;
      dialogMessage += '<br /><br /><b>Deseja continuar?</b>';

      this.showDialog('Atenção!', dialogMessage, 'custom-pause-end', '', false, 'center', 400);
    },

    //
    //
    // SAI DO MODO DE EDIÇÃO/REGISTRO DAS PAUSAS
    //
    //
    //

    stopEditingCustomPauseTime() {
      this.customPauseStatus = 'waiting';
      this.pauseStartDateAndTime = '';
      this.pauseEndDateAndTime = '';
    },

    //
    //
    //
    // INICIA MODO DE EDIÇÃO DO PLANTÃO
    //
    //
    //

    editDuty ()
    {
      if (this.isCancelled) return false

      this.isEditing = true

      this.campoValor = this.plantaoValor
      this.fieldPaidPartialValue = this.dutyPaidPartialValue
    },

    //
    //
    //
    // SALVAR / ATUALIZAR PLANTÃO
    //
    //
    //

    // Valida o NOVO plantonista (troca de profissional) contra as regras de carga
    // horária deste plantão. Mesma engine do Criar; ignore_duty_ids exclui o próprio
    // plantão do conjunto existente. Best-effort: falha não trava a edição.
    async checkOwnerWorkingHoursRules (newOwnerId)
    {
      try {
        const owner = String(newOwnerId || '')
        if (!this.duty || owner === '' || owner === '0') return { block: false, warn: false }

        const groupId = this.duty.groupID || this.groupID || this.$route.params.groupID

        const item = {
          candidate_id: this.dutyID,
          duty_id: this.dutyID,
          user_id: owner,
          scale_id: this.duty.scaleID,
          start_at: buildStartAtISO(moment(this.duty.data_inicio).format('YYYY-MM-DD'), this.duty.hora_inicio),
          duration_minutes: durationHoursToMinutes(this.duty.periodo),
        }

        const result = await this.$store.dispatch('VALIDATE_RULES_BATCH', {
          groupId,
          items: [item],
          operation: 'update',
          options: { ignore_duty_ids: [this.dutyID] },
        })

        const data = result && result.data ? result.data : result
        if (!data || !data.violated) return { block: false, warn: false }

        const message = [...new Set((data.violations || []).map(v => v.message))].join('<br>')

        if (data.summary_action === 'block' || !data.can_force_create) return { block: true, message }

        return { warn: true, message }
      } catch (e) {
        return { block: false, warn: false }
      }
    },

    async saveDuty (validateConflicts = true, validateRules = true)
    {
      if (this.isLoading || this.isCancelled) return false

      const campoValor = this.campoValor || 0
      const plantaoValor = this.plantaoValor || 0

      const campoObservacao = String(this.campoObservacao).trim()
      const plantaoObservacao = String(this.plantaoObservacao).trim()

      //
      //
      //
      // VERIFICAR SE HOUVE ALTERAÇÃO
      //
      //
      //

      const hasNewValue = plantaoValor !== campoValor
      const hasNewObservation = plantaoObservacao !== campoObservacao
      const selectedNewOwner = this.plantonistaID !== this.campoPlantonistaSelecionado

      const paymentStatusChanged = this.dutyPaymentStatus !== this.fieldPaymentStatus
      const hasNewValuePartial = this.dutyPaidPartialValue !== this.fieldPaidPartialValue

      if (!hasNewValue && !hasNewValuePartial && !hasNewObservation && !paymentStatusChanged && !selectedNewOwner)
      {
        this.isEditing = false
        return false
      }

      //
      // ------------------------------------------------------------------------
      //
      // Pagamento Parcial (Adiantamento) - Regra de negócio
      //
      // Mantido pelo Firmino para evitar chamada do canAddUserShift e reduzir/economizar carregamentos
      //
      // ------------------------------------------------------------------------
      //

      // JESUS: Colocar no back-end laravel
      if (this.fieldPaymentStatus === 'PARTIAL')
      {
        if (this.fieldPaidPartialValue === 0) return this.showMessage('Atenção!', 'Informe um valor em "Valor adiantado" ou selecione outra opção em "Pagamento realizado?".')
        if (this.fieldPaidPartialValue >= campoValor) return this.showMessage('Atenção!', `Você está informando um pagamento adiantado <span style="color: dodgerblue">(${formatMoney(this.fieldPaidPartialValue)})</span> maior que o valor total do plantão <span style="color: dodgerblue">(${formatMoney(campoValor)})</span>. Deseja informar o pagamento completo? Selecione a opção "Sim (completo)".`)
      }

      // Zera o valor caso o usuário selecione uma opção diferente de "Sim (Parcial)" e esqueça de zerar
      // if (this.fieldPaymentStatus !== 'PARTIAL') this.fieldPaidPartialValue = 0

      //
      // CONFLITOS
      //

      if (validateConflicts && selectedNewOwner)
      {
        // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
        const { code } = this.checkConflicts(this.campoPlantonistaSelecionado, 'changeUser')
        if (code === 'STOP') return false
      }

      //
      // REGRAS DE CARGA HORÁRIA (novo plantonista)
      //

      if (validateRules && selectedNewOwner)
      {
        const ruleCheck = await this.checkOwnerWorkingHoursRules(this.campoPlantonistaSelecionado)

        if (ruleCheck.block)
        {
          return this.showMessage('Ação bloqueada', ruleCheck.message)
        }

        if (ruleCheck.warn)
        {
          this.showDialog('Alerta de violação', `<div style="text-align: center">${ruleCheck.message}<br /><br /><b>Deseja alterar o plantonista mesmo assim?</b></div>`, 'changeUserRules', '', false, 'center', 400)
          return false
        }
      }

      //
      // ATUALIZAR DADOS DO PLANTÃO
      //

      this.isLoading = true

      const request = await apiUpdateDuty({
        viewerID: apiGetUserId(),
        dutyID: this.dutyID,

        selectedPaidStatus: this.fieldPaymentStatus,
        selectedOwnerID: this.campoPlantonistaSelecionado,
        observation: campoObservacao,
        value: campoValor,
        paidPartialValue: this.fieldPaidPartialValue,
      })

      this.isEditing = false

      if (request.code !== 'OK')
      {
        this.campoValor = plantaoValor
        this.campoObservacao = plantaoObservacao

        this.fieldPaymentStatus = this.dutyPaymentStatus
        this.fieldPaidPartialValue = this.dutyPaidPartialValue

        this.isLoading = false

        // Mostra a resposta do back-end
        return this.showMessage(request.title, request.code === 'INVALID' ? request.message.join('\r\n') : request.message)
      }

      // Recarrega os dados do plantão a fim de atualizar a tela
      await this.loadDuty()
    },

    //
    //
    //
    // CÓDIGO REPETITIVO OU TRANSFORMADO EM FUNÇÃO PARA FACILITAR A MANUTENÇÃO
    //
    //
    //

    async setDutyCandidates (shift)
    {
      let candidates = !!shift === true && !!shift.candidates === true ? Object.entries(shift.candidates) : []

      candidates = candidates.length > 0 ? (await Promise.all(
        candidates.map(async ([candidateId, candidateApplicationTime]) => {
          // USUÁRIO QUE DISPAROU O EVENTO
          const candidate = await apiGetUserDetails(candidateId)

          const candidateImage = !!candidate && !!candidate.img && typeof candidate.img === 'string' && candidate.img.indexOf('https://') !== -1 ? String(candidate.img) : userProfileBroken
          const candidateName = !!candidate && !!candidate.nome ? String(candidate.nome).trim() : ''
          const candidateEmail = !!candidate && !!candidate.email ? String(candidate.email).trim() : ''

          return candidate ? {
            applicationTime: candidateApplicationTime,
            // applicationTimeFormatted: moment(candidateApplicationTime).format('DD/MM/YYYY [às] HH:mm:ss'),
            candidateId,
            candidateImage,
            candidateName: candidateName || candidateEmail,
            formattedAppliedTime: moment(candidateApplicationTime).format('DD/MM/YYYY [às] HH:mm:ss'),
            // candidateName: candidateName.length > 0 ? candidateName.split(' ')[0] : '',
            // candidateEmail,
          } : false
        })
      )).filter(valid => !!valid) : []

      if (candidates.length > 0) {
        candidates.sort((a, b) => a.applicationTime - b.applicationTime)
      }

      this.candidates = candidates
    },

    setShiftStatus ()
    {
      // Cancelado pelos gestores
      // Disponível (Vencido ou Disponível)
      // Iniciado
      // Encerrado
      // Assumido (Vencido ou Assumido)

      if (this.isCancelled)
      {
        this.dutyStatus = 'Cancelado pelos gestores'
        this.dutyStatusImage = userProfileCancelado
      }
      else if (this.isAvailable)
      {
        this.dutyStatus = this.isExpired ? 'Vencido' : 'Disponível'
        this.dutyStatusImage = this.isExpired ? userProfileCancelado : userProfileAvailable
      }
      else
      {
        if (this.dutyProgressStatus === 'started')
        {
          this.dutyStatus = this.lastShiftBreak.status === 'started' ? 'Pausado...' : (this.lastShiftBreak.status === 'finished' ? 'Iniciou, pausou e retornou da pausa...' : 'Iniciado')
          this.dutyStatusImage = dutyStatusStarted
        }
        else if (this.dutyProgressStatus === 'finished')
        {
          this.dutyStatus = 'Encerrado'
          this.dutyStatusImage = dutyStatusFinished
        }
        else
        {
          this.dutyStatus = this.isExpired ? 'Vencido' : 'Assumido'
          this.dutyStatusImage = this.isExpired ? userProfileCancelado : dutyStatusOwned
        }
      }
    },

    async checkConflicts (userId, cmd)
    {
      const dataInicioPlantao = (this.isNewTZ ? moment.utc(this.plantaoDataInicio) : moment(this.plantaoDataInicio)).format('DD/MM/YYYY')
      const dutyStartTime = valueToTime(this.plantaoHoraInicio)

      const { conflictedScales = [], conflictsTableHtml = '' } = await canAddUserShift(dutyStartTime, [dataInicioPlantao], userId, this.firstDate, this.lastDate)

      if (conflictedScales.length > 0)
      {
        const foundUser = this.groupUsers.find(user => user.userID === userId)
        const foundUserName = (foundUser ?? {})?.userName ? `<b style="color: #778899">${foundUser.userName}</b>` : 'O usuário selecionado'

        this.showConfirmBox({
          title: 'Conflito!',
          text: `<div style="text-align: center">${foundUserName} já tem um plantão nesse mesmo dia e horário.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja mudar o plantonista mesmo assim?</b></div>`,
          type: cmd,
          data: cmd === 'accept-duty-candidate' ? { candidateId: userId, validateConflicts: false } : '',
          isResponse: false,
          buttonPosition: 'right',
          width: 330,
          closeText: 'Não',
          continueText: 'Sim',
        })

        return { code: 'STOP' }
      }

      return { code: 'CONTINUE' }
    },

    //
    //
    //
    // GESTÃO DA JANELA DIVIDIR PLANTÃO
    //
    //
    //

    openSplitShiftModal ()
    {
      const dutyScale = this.processedGroupScales.find(scale => scale.scaleID === this.scaleID)

      // Abre o dialog de dividir
      this.$refs.splitShiftModal.open({
        groupID: this.groupID,
        scaleID: this.scaleID,
        shiftID: this.dutyID,
        waitingDutyID: this.waitingDutyID,
        dutyName: this.dutyScaleName,
        dutyLocal: this.dutyLocation,
        dutyValue: this.plantaoValor,
        dutyPaidPartialValue: this.dutyPaidPartialValue,
        breaks: this.duty.breaks || null,
        lastbreakid: this.duty.lastbreakid || null,
        lastbreakstatus: this.duty.lastbreakstatus || null,
        fbLogs: this.fbLogs,
        dutyProgressStatus: this.dutyProgressStatus,
        dutyStartLocation: this.duty.start_location || null,
        dutyEndLocation: this.duty.end_location || null,
        users: this.campoPlantonistaOpcoes.filter(opt => !!opt.disabled === false),
        dutyScaleUsers: !!dutyScale === true && !!dutyScale.scaleUsers === true && typeof dutyScale.scaleUsers === 'object' && Array.isArray(dutyScale.scaleUsers) === false ? dutyScale.scaleUsers : null,
        startDateTime: this.shiftDateTimeJsObject,
        duration: this.shiftDuration,
      })
    },

    onSplitShiftModalClose (cdResponse)
    {
      if (cdResponse === false) return false

      // console.log('::: onSplitShiftModalClose:', cdResponse)
    },

    onSplitShiftSuccess ()
    {
      this.closeDialog()
    },

    //
    //
    //
    // GESTÃO DAS ABAS
    //
    //
    //

    setTab (tab = 'summary') {
      this.groupTab = tab
    },

    setChildTab (tab = 'ponto') {
      this.groupChildTab = tab
    },

    //
    //
    //
    // Eventos dos campos de valor
    //
    //
    //

    onBlurMoneyValue (moneyValue)
    {
      this.campoValor = moneyValue
    },

    onBlurPartialValue (moneyValue)
    {
      this.fieldPaidPartialValue = moneyValue
    },

    //
    //
    //
    // Desabilita datas e horários anteriores ao início
    //
    // Jesus: Ainda não permite selecionar início adiantado
    //
    //
    //

    customStartDisabledDate (date) {
      const checkoutDate = this.ownerEndDateJsObject;
      const shiftStartDay = this.shiftDateJsObject;

      const isBeforeShiftStart = date.getTime() < shiftStartDay.getTime();

      if (checkoutDate) {
        const dayAfterCheckout = moment(checkoutDate).startOf('day').add(1, 'day').valueOf();
        const isAfterCheckout = date.getTime() >= dayAfterCheckout;
        return isBeforeShiftStart || isAfterCheckout;
      }

      return isBeforeShiftStart;
    },

    customStartDisabledTime(time) {
      const checkoutDateTime = this.ownerEndDateJsObject;

      const shiftStartLimit = this.shiftDateTimeJsObject.getTime() - 3600000;
      if (time.getTime() < shiftStartLimit) {
        return true;
      }

      if (!checkoutDateTime) {
        return false;
      }

      const momentTime = moment(time);
      const momentCheckout = moment(checkoutDateTime);

      if (momentTime.isAfter(momentCheckout, 'day')) {
        return true;
      }

      if (!momentTime.isSame(momentCheckout, 'day')) {
        return false;
      }

      const limitHour = momentCheckout.hour();
      const limitMinute = momentCheckout.minute();
      const currentHour = time.getHours();
      const currentMinute = time.getMinutes();

      // DESABILITA se:
      // - Hora atual > hora do checkout, OU
      // - Hora atual = hora do checkout E minuto >= minuto do checkout
      if (currentHour > limitHour) {
        return true;
      }

      if (currentHour === limitHour && currentMinute >= limitMinute) {
        return true;
      }

      return false;
    },

    //
    //
    //
    // Desabilita datas e horários anteriores ao início real
    //
    //
    //

    // Ainda não foi iniciado

    customEndDisabledDate (date) {
      const timestamp = isDateTime(this.startDateAndTime) ? moment(this.startDateAndTime.split(' ')[0], 'DD/MM/YYYY').valueOf() : this.shiftDateJsObject.getTime()

      return date.getTime() < timestamp
    },

    customEndDisabledTime (time, date) {
      const timestamp = isDateTime(this.startDateAndTime) ? moment(this.startDateAndTime, 'DD/MM/YYYY HH:mm:ss').valueOf() : this.shiftDateTimeJsObject.getTime()

      // Permite selecionar horários no mínimo 1 minuto depois do início
      return time.getTime() < timestamp + (60 * 1000)
    },

    //
    //
    //
    // Usado apenas para limitar o FIM de um plantão que já foi iniciado...
    //
    //
    //

    customEndDisabledDateForRealStart (date) {
      return date.getTime() < this.ownerStartDateJsObject.getTime()
    },

    customEndDisabledTimeForRealStart (time, date) {
      // console.log('::: customEndDisabledTimeForRealStart:', { horario: time, inicio: this.ownerStartDateTimeJsObject })

      // Permite selecionar horários no mínimo 1 minuto depois do início
      return time.getTime() < this.ownerStartDateTimeJsObject.getTime() + (60 * 1000)
    },

    //
    //
    //
    // ABERTURA DA CAIXA DE MENSAGEM
    //
    // EXECUTA AS FUNCIONALIDADES QUE O USUÁRIO CONFIRMOU A EXECUÇÃO
    //
    //
    //

    async cdAction (cdResponse)
    {
      if (cdResponse === false) return false

      //
      //
      //

      if (cdResponse.cdType === 'delete-checkout')
      {
          this.isLoading = true

          try {
            const response = await apiDeleteCheckout(this.dutyID, this.userSession?.uid)

            if (response.code === 0)
            {
              this.isLoading = false
              return this.showMessage('Erro', response.message || 'Ocorreu um erro ao apagar o checkout. Tente novamente.')
            }

            if(response.httpCode && response.httpCode !== 204) {
              this.isLoading = false
              return this.showMessage('Erro', response.message || 'Ocorreu um erro ao apagar o checkout. Tente novamente.')
            }

            // Recarrega os dados do plantão para atualizar a tela
            await this.loadDuty()
          } catch (error) {
            console.error('Erro ao apagar checkout:', error)
            this.isLoading = false
            this.showMessage('Erro', 'Ocorreu um erro ao apagar o checkout. Tente novamente.')
          }
      }

      if (cdResponse.cdType === 'copy-checkin-to-checkout')
      {
        if (this.isLoading || !this.duty?.start_location || !this.ownerStartTimeObj) return false

        this.isLoading = true

        const startLoc = this.duty.start_location || {}

        const response = await apiFinishDuty({
          origin: 'WEB',
          viewerID: apiGetUserId() || this.userSession?.uid || '',
          dutyID: this.dutyID,
          datetime: this.ownerStartTimeObj.format('DD/MM/YYYY HH:mm'),
          // Preserve full precision from the recorded start_location
          latitude: typeof startLoc.latitude !== 'undefined' ? String(startLoc.latitude) : '0.0',
          longitude: typeof startLoc.longitude !== 'undefined' ? String(startLoc.longitude) : '0.0',
          observation: String(this.shiftExecutionObservation).trim(),
          copy_from_checkin: true,
          // Ensure backend receives original timestamp (ms or unix as stored)
          copy_timestamp: startLoc.timestamp || '',
          // Copy the device object so it can be persisted into end_location
          userDevice: startLoc.device || {},
        })

        if (response.code === 0) {
          this.isLoading = false
          return this.showMessage(response.title, response.message)
        }

        await this.loadDuty()
      }

      if (cdResponse.cdType === 'undo-shift-execution-time')
      {
        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const response = await apiUndoShiftExecutionTime(this.dutyID, this.shiftExecutionObservation)

        // this.isEditing = false

        // Trata a resposta do back-end
        if (response.code === 0)
        {
          // Termina o carregamento na tela
          this.isLoading = false

          return false
        }

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }

      //
      //
      //

      if (cdResponse.cdType === 'custom-start-shift')
      {
        if (!isDateTime(this.startDateAndTime)) return false

        // Mostra o carregamento na tela
        this.isLoading = true
        const isUpdating = !!this.ownerStartTime
        let response;

        try {
          if (isUpdating) {

            response = await apiUpdateCheckin({
              origin: 'WEB',
              viewerID: this.userSession?.uid || '',
              dutyID: this.dutyID,
              datetime: this.startDateAndTime
            })
          } else {
            response = await apiStartDuty({
              origin: 'WEB',
              viewerID: this.userSession?.uid || '',
              dutyID: this.dutyID,
              datetime: this.startDateAndTime
            })
          }
        } catch (error) {
          console.error('Erro ao iniciar/atualizar o plantão:', error)
          this.isLoading = false
          return this.showMessage('Erro', 'Ocorreu um erro ao iniciar/atualizar o plantão. Tente novamente.')
        }

        // this.isEditing = false

        // Trata a resposta do back-end
        if (response.code === 0) {
          // Termina o carregamento na tela
          this.isLoading = false
          // Mostra a resposta do back-end
          return this.showMessage(response.title, response.message)
        }

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }

      //
      //
      //

      if (cdResponse.cdType === 'custom-end-shift')
      {
        if (!isDateTime(this.endDateAndTime)) return false

        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const response = await apiFinishDuty({ origin: 'WEB', viewerID: this.userSession?.uid || '', dutyID: this.dutyID, datetime: this.endDateAndTime, observation: String(this.shiftExecutionObservation).trim() })

        // this.isEditing = false

        // Trata a resposta do back-end
        if (response.code === 0) {
          // Termina o carregamento na tela
          this.isLoading = false
          // Mostra a resposta do back-end
          return this.showMessage(response.title, response.message)
        }

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }

      //
      //
      //

      if (cdResponse.cdType === 'custom-pause-start')
      {
        if (!isDateTime(this.pauseStartDateAndTime)) return false

        if (!this.userSession?.uid) {
          return this.showMessage('Erro', 'Usuário não identificado. Recarregue a página.')
        }

        this.isLoading = true
        const response = await apiUpdatePause({
          origin: 'WEB',
          viewerID: this.userSession.uid,
          dutyID: this.dutyID,
          pauseStartDateTime: this.pauseStartDateAndTime,
          type: 'start'
        })

        if (response.code === 0) {
          this.isLoading = false
          this.stopEditingCustomPauseTime()
          return this.showMessage(response.title, response.message)
        }

        this.stopEditingCustomPauseTime()
        this.showMessage(response.title, response.message)
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.loadDuty()
        this.isLoading = false
      }

      if (cdResponse.cdType === 'custom-pause-end')
      {
        if (!isDateTime(this.pauseEndDateAndTime)) return false

        if (!this.userSession?.uid) {
          return this.showMessage('Erro', 'Usuário não identificado. Recarregue a página.')
        }

        this.isLoading = true
        const response = await apiUpdatePause({
          origin: 'WEB',
          viewerID: this.userSession.uid,
          dutyID: this.dutyID,
          pauseEndDateTime: this.pauseEndDateAndTime,
          type: 'end'
        })

        if (response.code === 0) {
          this.isLoading = false
          this.stopEditingCustomPauseTime()
          return this.showMessage(response.title, response.message)
        }

        this.stopEditingCustomPauseTime()
        this.showMessage(response.title, response.message)
        await new Promise(resolve => setTimeout(resolve, 500))
        await this.loadDuty()
        this.isLoading = false
      }

      //
      //
      //

      if (cdResponse.cdType === 'refuse-duty-candidate')
      {
        if (this.isLoading || this.isCancelled) return false

        const candidateId = cdResponse.cdData

        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const response = await apiCancelShiftRequest(this.dutyID, candidateId)

        // Sai do modo de edição
        this.isEditing = false

        // Trata a resposta do back-end
        if (response.code === 0)
        {
          // Termina o carregamento na tela
          this.isLoading = false

          return false
        }

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }

      //
      //
      //

      if (cdResponse.cdType === 'accept-duty-candidate')
      {
        if (this.isLoading || this.isCancelled) return false
        // if (this.isLoading) return false

        const { candidateId, validateConflicts } = cdResponse.cdData

        // Verifica se houve alteração
        const selectedNewOwner = this.plantonistaID !== candidateId
        if (!selectedNewOwner) {
          this.isEditing = false
          return false
        }

        // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
        if (validateConflicts && selectedNewOwner) {
          const { code } = this.checkConflicts(candidateId, 'accept-duty-candidate')
          if (code === 'STOP') return false
        }

        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const response = await apiUpdateShiftOwner(this.plantaoDataInicio, this.dutyID, candidateId)

        // Sai do modo de edição
        this.isEditing = false

        // Trata a resposta do back-end
        if (response.code === 0)
        {
          // Termina o carregamento na tela
          this.isLoading = false

          return false
        }

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }

      //
      // Confirmar ALTERAÇÃO DE USUÁRIO em conflito/que já tem plantão em outra escala (ou grupo?)
      //

      if (cdResponse.cdType === 'changeUser')
      {
        if (this.isLoading) return false

        this.saveDuty(false)
      }

      if (cdResponse.cdType === 'changeUserRules')
      {
        if (this.isLoading) return false

        this.saveDuty(false, false)
      }

      //
      // Apagar plantão
      //

      if (cdResponse.cdType === 'delete-duty')
      {
        if (this.isLoading) return false

        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const response = await apiDeleteDuty(this.userSession?.uid || '', this.dutyID)

        // Termina o carregamento na tela
        this.isLoading = false

        // Mostra a resposta do back-end
        if (response.code === 0) {
          this.showMessage(response.title, response.message)
        } else {
          this.showDialog(response.title, response.message, 'close-modal', '', true, 'right', 400, true)
        }
      }

      //
      //
      //

      if (cdResponse.cdType === 'close-modal')
      {
        // Fecha a janela
        this.closeDialog()
      }

      //
      // Cancelar passagem do plantão
      //

      if (cdResponse.cdType === 'cancel-duty-sharing')
      {
        if (this.isLoading) return false

        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const response = await apiRefuseDuty(this.dutyID, this.groupID, true, true)

        // Termina o carregamento na tela
        this.isLoading = false

        // Mostra a resposta do back-end
        if (response.code === 0) return this.showMessage('Aviso!', 'Não foi possível cancelar a passagem do plantão. Por favor, tente novamente ou fale com nosso suporte.')

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }

      //
      // Aceitar passagem do plantão
      //

      if (cdResponse.cdType === 'accept-duty-sharing')
      {
        if (this.isLoading) return false

        // Mostra o carregamento na tela
        this.isLoading = true

        // Executa
        const request = await apiAcceptDuty({ dutyID: this.dutyID, viewerID: apiGetUserId() })

        // Termina o carregamento na tela
        this.isLoading = false

        // Mostra a resposta do back-end
        if (request.code !== 'OK') return this.showMessage(request.title, request.code === 'INVALID' ? request.message.join('\r\n') : request.message)

        // Recarrega os dados do plantão a fim de atualizar a tela
        await this.loadDuty()
      }
    },

    //
    //
    //
    // PROCESSAR O HISTÓRICO DO PLANTÃO
    //
    //
    //

    async processarHistorico (logsResponse)
    {
      const logs = logsResponse.length > 0 ? (await Promise.all(
        logsResponse.map(async ([dutyID, log], index) => {
          // VERSÃO DO LOG
          const isNewFormat = !!log.event && !!log.version && log.version === '1'

          // DATA DO EVENTO
          const eventDate = log.timestamp * 1
          // const eventDate = moment(log.timestamp * 1).format('DD/MM/YYYY [às] HH:mm:ss')

          // USUÁRIO QUE DISPAROU O EVENTO
          const eventOwner = await apiGetUserDetails(log.uid)

          const eventOwnerProfile = {
            userID: log.uid,
            userName: eventOwner.nome || 'ERRO',
            userImage: eventOwner.img || userProfileBroken,
          }

          //
          //
          //
          // FORMATO NOVO
          //
          //
          //

          if (isNewFormat)
          {
            const isSplit = this.duty.split || false

            const statusNewAvailableDuty = log.event === 'new_available_duty' // Plantão CRIADO como DISPONÍVEL
            const statusNewAssignedDuty = log.event === 'new_assigned_duty' && index === 0 // Plantão CRIADO com USUÁRIO ATRIBUÍDO
            const statusNewSplitedDuty = log.event === 'new_assigned_duty' && index > 0 && isSplit // Plantão DIVIDIDO
            const statusDutyDropped = log.event === 'user_pass_to_group' // Plantão PASSADO para DISPONÍVEL (passado para o grupo)
            const statusAssignedDuty = log.event === 'catched_by_user' // PEGARAM o PLANTÃO DISPONIBILIZADO
            const statusDutyStarted = log.event === 'started' // Plantão INICIADO
            const statusDutyFinished = log.event === 'finished' // Plantão ENCERRADO
            const statusSharedDuty = log.event === 'user_pass_to_user' // Plantão PASSADO de USUÁRIO PARA USUÁRIO
            const statusRequested = log.event === 'requested' // Usuário SOLICITOU plantão ou CANCELOU A SOLICITAÇÃO
            const statusPaid = log.event === 'paid_status'
            const statusUnknown = log.event === 'unknown' // Desconhecido
            const statusCheckinUpdated = log.event === 'checkin_updated' // Usuário ATUALIZOU o check-in
            const statusCheckoutDeleted = log.event === 'checkout_deleted' // Usuário APAGOU o checkout
            const statusPauseUpdated = log.event === 'pause_updated' // Usuário ATUALIZOU a pausa

            //
            //
            //

            // const isNew = !!log.before === false
            const isUpdate = !!log.before && !!log.after
            // const isDelete = !!log.before && !!log.after === false

            //
            // ?
            //

            const beforeDetails = await getHistoryDetails(log.before)
            const afterDetails = await getHistoryDetails(log.after)

            const uidRecebendoBefore = beforeDetails.receptor.userID
            const uidRecebendoAfter = afterDetails.receptor.userID

            const isRequestingAcceptance = uidRecebendoBefore.length === 0 && uidRecebendoAfter.length > 0
            const wasAcceptanceRequestCompleted = uidRecebendoBefore.length > 0 && uidRecebendoAfter.length === 0

            // console.log('::: beforeDetails > getHistoryDetails:', log.before, beforeDetails, uidRecebendoBefore)
            // console.log('::: afterDetails > getHistoryDetails:', log.after, afterDetails, uidRecebendoAfter)

            //
            // ?
            //

            let evento = { image: '', text: '' }
            let status = { image: '', text: '' }

            //
            // ?
            //

            // Plantão CRIADO como DISPONÍVEL
            if (statusNewAvailableDuty) {
              const r = formatNewAvailableDuty(afterDetails)
              evento = r.evento
              status = r.status
            }

            // Plantão CRIADO com USUÁRIO ATRIBUÍDO
            if (statusNewAssignedDuty && !statusNewSplitedDuty) {
              const r = formatNewAssignedDuty({ afterDetails, eventOwnerProfile })
              evento = r.evento
              status = r.status
            }

            // Plantão DIVIDIDO
            if (statusNewSplitedDuty) {
              const r = formatNewSplitedDuty({ afterDetails, eventOwnerProfile })
              evento = r.evento
              status = r.status
            }

            // Plantão PASSADO para DISPONÍVEL (passado para o grupo)
            if (statusDutyDropped)
            {
              const r = formatDutyDropped(log, beforeDetails, eventOwnerProfile)
              evento = r.evento
              status = r.status
            }

            // PEGARAM o PLANTÃO DISPONIBILIZADO
            if (statusAssignedDuty) {
              const r = formatDutyAssigned(log, afterDetails, eventOwnerProfile)
              evento = r.evento
              status = r.status
            }

            // Plantão INICIADO
            if (statusDutyStarted)
            {
              const r = formatDutyStarted({
                afterDetails,
                eventOwnerProfile
              });

              evento = r.evento
              status = r.status
            }

            // Plantão ENCERRADO
            if (statusDutyFinished) {
              const r = formatDutyFinished({
                afterDetails,
                eventOwnerProfile
              });

              evento = r.evento
              status = r.status
            }

            // PAGAMENTO REALIZADO?
            if (statusPaid)
            {
              const changedByOwner = log.uid === beforeDetails.owner.userID

              const desmarcou = !!beforeDetails.paid === true && !!afterDetails.paid === false

              /* evento.image = eventOwnerProfile.userImage || userProfileBroken
              evento.text = `${fmtUN(eventOwnerProfile.userName)} marcou o pagamento do plantão como ${desmarcou ? 'desfeito' : 'feito'}`

              status.image = dutyEdited
              status.text = desmarcou ? 'Pagamento desfeito' : 'Pagamento feito' */

              evento.image = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
              evento.text = changedByOwner ? (
                `${fmtAN(beforeDetails.owner.userName)} alterou detalhes do plantão`
              ) : (
                `${fmtAN(eventOwnerProfile.userName)} alterou detalhes do plantão ${beforeDetails.status === 'aberto' ? 'do grupo' : ('de ' + fmtUN(beforeDetails.owner.userName))}`
              )

              status.image = dutyEdited
              status.text = desmarcou ? 'Pagamento marcado como desfeito' : 'Pagamento marcado como feito'
            }

            if (statusCheckinUpdated)
            {
              const r = formatCheckinUpdated({
                afterDetails,
                eventOwnerProfile
              });

              evento = r.evento
              status = r.status
            }

            // Plantão: CHECK-OUT APAGADO
            if (statusCheckoutDeleted)
            {
              const r = formatCheckoutDeleted({
                eventOwnerProfile,
                afterDetails
              });

              evento = r.evento
              status = r.status
            }

            // Plantão: PAUSA ATUALIZADA
            if (statusPauseUpdated)
            {
              const r = formatPauseUpdated({
                afterDetails,
                eventOwnerProfile
              });

              evento = r.evento
              status = r.status
            }

            /*

                const changedByOwner = log.uid === beforeDetails.owner.userID

                if (wasCancelled) // VALIDAR
                {
                  evento.image = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
                  evento.text = changedByOwner ? `Cancelado por ${fmtUN(beforeDetails.owner.userName)}` : `Plantão de ${fmtUN(beforeDetails.owner.userName)} cancelado por ${fmtAN(eventOwnerProfile.userName)}`

                  status.image = userProfileCancelado
                  status.text = 'Plantão cancelado'
                }
                else if (valueChanged || observationChanged)
                {
                  evento.image = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
                  evento.text = changedByOwner ? `${fmtAN(beforeDetails.owner.userName)} alterou detalhes do plantão` : `${fmtAN(eventOwnerProfile.userName)} alterou detalhes do plantão ${beforeDetails.status === 'aberto' ? 'do grupo' : ('de ' + fmtUN(beforeDetails.owner.userName))}`

            */

            // Plantão solicitado ou solicitação cancelada
            if (statusRequested)
            {
              const differences = compareObjects(beforeDetails.candidates, afterDetails.candidates)

              //
              // USUÁRIO SOLICITOU PLANTÃO DISPONÍVEL
              //

              if (differences.addedKeys.length === 1 && differences.deletedKeys.length === 0)
              {
                const newCandidate = await apiGetUserDetails(differences.addedKeys[0])
                const newCandidateName = !!newCandidate && !!newCandidate.nome ? String(newCandidate.nome).trim() : 'ERRO'
                const newCandidateImage = !!newCandidate && !!newCandidate.img && typeof newCandidate.img === 'string' && newCandidate.img.indexOf('https://') !== -1 ? newCandidate.img : userProfileBroken

                evento.image = newCandidateImage
                evento.text = `${fmtUN(newCandidateName)} solicitou o plantão livre`

                status.image = userProfileAvailable
                status.text = 'Plantão aberto'
              }

              //
              // USUÁRIO CANCELOU A SOLICITAÇÃO
              //

              else if (differences.addedKeys.length === 0 && differences.deletedKeys.length === 1)
              {
                const candidateID = differences.deletedKeys[0]
                const changedByCandidate = log.uid === candidateID

                const leftCandidate = await apiGetUserDetails(candidateID)
                const leftCandidateName = !!leftCandidate && !!leftCandidate.nome ? String(leftCandidate.nome).trim() : 'ERRO'
                const leftCandidateImage = !!leftCandidate && !!leftCandidate.img && typeof leftCandidate.img === 'string' && leftCandidate.img.indexOf('https://') !== -1 ? leftCandidate.img : userProfileBroken

                evento.image = changedByCandidate ? (
                  leftCandidateImage
                ) : (
                  eventOwnerProfile.userImage
                )
                evento.text = changedByCandidate ? (
                  `${fmtUN(leftCandidateName)} desistiu da solicitação para assumir o plantão`
                  // `${fmtUN(leftCandidateName)} cancelou a solicitação do plantão livre`
                ) : (
                  `${fmtAN(eventOwnerProfile.userName)} cancelou a solicitação de ${fmtUN(leftCandidateName)} para assumir o plantão`
                )

                //

                status.image = userProfileAvailable
                status.text = 'Plantão aberto'
              }

              //
              // DESCONHECIDO
              //

              else
              {
                evento.image = dutyEdited
                evento.text = 'Solicitação de plantão'

                status.image = dutyEdited
                status.text = 'Desconhecido'
              }
            }

            // Plantão PASSADO de USUÁRIO PARA USUÁRIO
            if (statusSharedDuty)
            {
              if (wasAcceptanceRequestCompleted)
              {
                // Y aceitou o plantão de Y -> Y recebeu o plantão

                const acceptedByReceptor = log.uid === beforeDetails.receptor.userID
                const acceptedByOwner = log.uid === beforeDetails.owner.userID

                evento.image = acceptedByReceptor ? beforeDetails.receptor.userImage : eventOwnerProfile.userImage
                // identificar quando é passado por admin
                evento.text = acceptedByReceptor ? (
                  `${fmtUN(afterDetails.owner.userName)} aceitou o plantão de ${fmtUN(beforeDetails.owner.userName)}`
                ) : (
                  (
                    acceptedByOwner ? (
                      `${fmtAN(eventOwnerProfile.userName)} aceitou a passagem do plantão entre ${fmtAN('ELE(A)')} e ${fmtUN(afterDetails.owner.userName)}`
                    ) : (
                      `${fmtAN(eventOwnerProfile.userName)} aceitou a passagem do plantão entre ${fmtUN(beforeDetails.owner.userName)} e ${fmtUN(afterDetails.owner.userName)}`
                    )
                  )
                )

                status.image = afterDetails.owner.userImage
                status.text = `${fmtUN(afterDetails.owner.userName)} recebeu o plantão`
              }
              else
              {
                const statusCancelled = (
                  isUpdate &&
                  !!afterDetails.status &&
                  afterDetails.status === 'cancelado' &&
                  !!beforeDetails.status &&
                  beforeDetails.status !== 'cancelado'
                )

                if (statusCancelled) {
                  const r = formatDutyCancelled(log, afterDetails, beforeDetails, eventOwnerProfile)
                  evento = r.evento
                  status = r.status
                } else {
                  const r = formatDutyShared(log, afterDetails, beforeDetails, eventOwnerProfile)
                  evento = r.evento
                  status = r.status
                }
              }
            }

            // Desconhecido
            if (statusUnknown)
            {
              if (!isUpdate)
              {
                evento.image = dutyEdited
                evento.text = 'Desconhecido'

                status.image = dutyEdited
                status.text = 'Desconhecido'
              }
              else
              {
                const executionTimeUndone = beforeDetails.progress === 'finished' && afterDetails.progress === 'unknown'
                const startedAndDoneByManager = beforeDetails.progress === 'unknown' && afterDetails.progress === 'finished'
                const doneByManager = /* beforeDetails.progress === 'started' && */ afterDetails.progress === 'finished' && beforeDetails.owner !== afterDetails.uid

                const wasCancelled = beforeDetails.status !== 'cancelado' && afterDetails.status === 'cancelado'
                const valueChanged = beforeDetails.value !== afterDetails.value
                const observationChanged = beforeDetails.obs !== afterDetails.obs
                const changedByOwner = log.uid === beforeDetails.owner.userID

                if (wasCancelled) // VALIDAR
                {
                  evento.image = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
                  evento.text = changedByOwner ? `Cancelado por ${fmtUN(beforeDetails.owner.userName)}` : `Plantão de ${fmtUN(beforeDetails.owner.userName)} cancelado por ${fmtAN(eventOwnerProfile.userName)}`

                  status.image = userProfileCancelado
                  status.text = 'Plantão cancelado'
                }
                else if (valueChanged || observationChanged)
                {
                  evento.image = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
                  evento.text = changedByOwner ? `${fmtAN(beforeDetails.owner.userName)} alterou detalhes do plantão` : `${fmtAN(eventOwnerProfile.userName)} alterou detalhes do plantão ${beforeDetails.status === 'aberto' ? 'do grupo' : ('de ' + fmtUN(beforeDetails.owner.userName))}`

                  status.image = dutyEdited
                  if (!valueChanged && observationChanged) {
                    status.text = 'Observação alterada'
                  } else if (valueChanged && !observationChanged) {
                    status.text = 'Valor alterado'
                  } else {
                    status.text = 'Valor e observação alterados'
                  }
                }

                // !statusSharedDuty -> plantonista não mudou

                else if (!statusSharedDuty && isRequestingAcceptance)
                {
                  // X passou para Y -> Aguardando a resposta de Y

                  const sharedByOwner = log.uid === beforeDetails.owner.userID

                  evento.image = sharedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
                  // identificar quando é passado por admin
                  evento.text = sharedByOwner ? `${fmtUN(beforeDetails.owner.userName)} passou para ${fmtUN(afterDetails.receptor.userName)}` : `${fmtAN(eventOwnerProfile.userName)} passou o plantão de ${fmtUN(beforeDetails.owner.userName)} para ${fmtUN(afterDetails.receptor.userName)}`

                  status.image = afterDetails.receptor.userImage
                  status.text = `Aguardando a resposta de ${fmtUN(afterDetails.receptor.userName)}`
                }

                /* else if (statusSharedDuty && wasAcceptanceRequestCompleted)
                {
                  // Y aceitou o plantão de Y -> Y recebeu o plantão

                  const acceptedByReceptor = log.uid === beforeDetails.receptor.userID

                  evento.image = acceptedByReceptor ? beforeDetails.receptor.userImage : eventOwnerProfile.userImage
                  // identificar quando é passado por admin
                  evento.text = acceptedByReceptor ? `${fmtUN(afterDetails.owner.userName)} aceitou o plantão de ${fmtUN(beforeDetails.owner.userName)}` : `${fmtAN(eventOwnerProfile.userName)} aceitou o plantão de ${fmtUN(beforeDetails.owner.userName)} para ${fmtUN(afterDetails.owner.userName)}`

                  status.image = afterDetails.owner.userImage
                  status.text = `${fmtUN(afterDetails.owner.userName)} recebeu o plantão`
                } */

                else if (!statusSharedDuty && wasAcceptanceRequestCompleted)
                {
                  // Y recusou o plantão de Y -> X continua com o plantão

                  const refusedByOwner = log.uid === beforeDetails.owner.userID
                  const refusedByReceptor = log.uid === beforeDetails.receptor.userID

                  if (refusedByOwner)
                  {
                    evento.image = beforeDetails.owner.userImage
                    evento.text = `${fmtUN(beforeDetails.owner.userName)} desistiu de passar o plantão`
                  }
                  else if (refusedByReceptor)
                  {
                    evento.image = beforeDetails.receptor.userImage
                    evento.text = `${fmtUN(beforeDetails.receptor.userName)} recusou o plantão`
                  }
                  else
                  {
                    evento.image = eventOwnerProfile.userImage
                    evento.text = `${fmtAN(eventOwnerProfile.userName)} cancelou a passagem do plantão de ${fmtUN(beforeDetails.owner.userName)} para ${fmtUN(beforeDetails.receptor.userName)}`
                  }

                  status.image = afterDetails.owner.userImage
                  status.text = `${fmtUN(afterDetails.owner.userName)} continua com o plantão`

                  // identificar quando é passado por admin
                  // evento.text = refusedByOwner ? `${fmtUN(beforeDetails.owner.userName)} desfez a passagem do plantão de ${fmtUN(beforeDetails.owner.userName)}` : `${fmtAN(eventOwnerProfile.userName)} recusou o plantão de ${fmtUN(beforeDetails.owner.userName)} para ${fmtUN(afterDetails.owner.userName)}`
                }

                //
                //
                //

                else if (executionTimeUndone)
                {
                  evento.image = eventOwnerProfile.userImage
                  evento.text = `${fmtAN(eventOwnerProfile.userName)} desfez o registro de tempo do plantão de ${fmtUN(afterDetails.owner.userName)}`

                  status.image = afterDetails.owner.userImage
                  status.text = `${fmtUN(afterDetails.owner.userName)} continua com o plantão`
                }

                //
                //
                //

                else if (startedAndDoneByManager)
                {
                  evento.image = eventOwnerProfile.userImage
                  evento.text = `${fmtAN(eventOwnerProfile.userName)} encerrou o plantão de ${fmtUN(afterDetails.owner.userName)}`
                  // iniciou e encerrou

                  status.image = dutyStatusFinished
                  status.text = 'Plantão encerrado'
                }

                //
                //
                //

                else if (doneByManager)
                {
                  evento.image = eventOwnerProfile.userImage
                  evento.text = `${fmtAN(eventOwnerProfile.userName)} encerrou o plantão de ${fmtUN(afterDetails.owner.userName)}`

                  status.image = dutyStatusFinished
                  status.text = 'Plantão encerrado'
                }

                // Y não respondeu a solicitação de passagem -> X continua com o plantão

                else
                {
                  evento.image = dutyEdited
                  evento.text = 'Desconhecido.'

                  status.image = dutyEdited
                  status.text = 'Desconhecido.'
                }
              }
            }

            // console.log(`::: ${dutyID} -> evento, status:`, evento, status)

            //
            // ?
            //

            return log.timestamp ? {
              // timestamp: log.timestamp,
              dateFormatted: moment(eventDate).format('DD/MM/YYYY [às] HH:mm:ss'),
              date: eventDate,
              versao: '2',
              evento,
              status,
            } : false
          }

          //
          //
          //
          //
          //
          //
          //
          // FORMATO ANTIGO
          //
          //
          //
          //
          //
          //
          //

          else
          {
            // console.log('log:', eventDate, log)

            // event type
            const isNew = !!log.before === false
            const isUpdate = !!log.before && !!log.after
            const isDelete = !!log.before && !!log.after === false
            const isUnknown = !!log.before === false && !!log.after === false

            if (isUnknown)
            {
              /* return log.timestamp ? {
                // timestamp: log.timestamp,
                date: eventDate,
                versao: '1',
                evento: {
                  image: dutyEdited,
                  text: 'Desconhecido',
                },
                status: {
                  image: dutyEdited,
                  text: 'Desconhecido',
                },
              } : false */

              return false
            }

            //
            // ?
            //

            const beforeDetails = await getOldHistoryDetails(log.before, isDelete)
            const afterDetails = await getOldHistoryDetails(log.after, isNew)

            // console.log('::: beforeDetails > getOldHistoryDetails > isDelete:', log.before, beforeDetails, isDelete)
            // console.log('::: afterDetails > getOldHistoryDetails > isNew:', log.after, afterDetails, isNew)

            //
            // ?
            //

            const statusNewAvailableDuty = isNew && !!afterDetails.owner === false // Plantão CRIADO como DISPONÍVEL
            const statusNewAssignedDuty = isNew && !!afterDetails.owner && !!afterDetails.owner.userID // Plantão CRIADO com USUÁRIO ATRIBUÍDO
            const statusDutyDropped = isUpdate && !!beforeDetails.owner && !!beforeDetails.owner.userID && !!afterDetails.owner === false // Plantão PASSADO para DISPONÍVEL (passado para o grupo)
            const statusAssignedDuty = isUpdate && !!beforeDetails.owner === false && !!afterDetails.owner && !!afterDetails.owner.userID // PEGARAM o PLANTÃO DISPONIBILIZADO
            const statusSharedDuty = isUpdate && !!beforeDetails.owner && !!afterDetails.owner && beforeDetails.owner.userID !== afterDetails.owner.userID // Plantão PASSADO de USUÁRIO PARA USUÁRIO
            const statusCancelled = isUpdate && !!afterDetails.status && afterDetails.status === 'cancelado' && !!beforeDetails.status && beforeDetails.status !== 'cancelado'

            let evento = { image: '', text: '' }
            let status = { image: '', text: '' }

            //
            // Plantão CANCELADO
            //

            if (statusCancelled)
            {
              const changedByOwner = log.uid === beforeDetails.owner.userID

              evento.image = changedByOwner ? beforeDetails.owner.userImage : eventOwnerProfile.userImage
              evento.text = changedByOwner ? `Cancelado por ${fmtUN(beforeDetails.owner.userName)}` : `Plantão de ${fmtUN(beforeDetails.owner.userName)} cancelado por ${fmtAN(eventOwnerProfile.userName)}`

              status.image = userProfileCancelado
              status.text = 'Plantão cancelado'
            }
            else
            {
              // Plantão CRIADO como DISPONÍVEL
              if (statusNewAvailableDuty) {
                const r = formatNewAvailableDuty(afterDetails)
                evento = r.evento
                status = r.status
              }

              // Plantão CRIADO com USUÁRIO ATRIBUÍDO
              if (statusNewAssignedDuty) {
                const r = formatNewAssignedDuty({ afterDetails, eventOwnerProfile })
                evento = r.evento
                status = r.status
              }

              // Plantão PASSADO para DISPONÍVEL (passado para o grupo)
              if (statusDutyDropped)
              {
                const r = formatDutyDropped(log, beforeDetails, eventOwnerProfile)
                evento = r.evento
                status = r.status
              }

              // PEGARAM o PLANTÃO DISPONIBILIZADO
              if (statusAssignedDuty) {
                const r = formatDutyAssigned(log, afterDetails, eventOwnerProfile)
                evento = r.evento
                status = r.status
              }

              // Plantão PASSADO de USUÁRIO PARA USUÁRIO
              if (statusSharedDuty)
              {
                const r = formatDutyShared(log, afterDetails, beforeDetails, eventOwnerProfile)
                evento = r.evento
                status = r.status
              }

              // Desconhecido
              /* if (statusUnknown)
              {
                evento.image = dutyEdited
                evento.text = 'Desconhecido'

                status.image = dutyEdited
                status.text = 'Desconhecido'
              } */
            }

            // console.log(`::: ${dutyID} -> evento, status:`, evento, status)

            //
            // ?
            //

            return log.timestamp ? {
              // timestamp: log.timestamp,
              dateFormatted: moment(eventDate).format('DD/MM/YYYY [às] HH:mm:ss'),
              date: eventDate,
              versao: '1',
              evento,
              status,
            } : false
          }
        })
      )).filter(valid => !!valid) : []

      if (logs.length > 0) logs.sort((a, b) => b.timestamp - a.timestamp)

      return logs
    },

    // Método para focar no input de busca dentro do v-select de plantonista
    // OBS: necessário para o campo ser clicável e digitável
    focusSearchUserInput() {
      const inputElement = this.$refs.searchUserInputRef;

      if (inputElement && inputElement.focus) {
        inputElement.focus();
      }
    },

    // Método para lidar com mudança no v-select de plantonista
    onPlantonistaSelectChange(value) {
      // Se o valor for null, undefined ou vazio (quando clica no X)
      if (!value || value === null || value === undefined || value === '') {
        this.campoPlantonistaSelecionado = '0';
        this.searchUserText = ''; // Limpa o campo de busca
      } else {
        // Se selecionou um usuário válido, atualiza normalmente
        this.campoPlantonistaSelecionado = value;
      }
    },

    onPlantonistaBlur() {
      this.searchUserText = '';
    },

    // Método para detectar quando o menu do v-select abre/fecha
    startPlantonistaMenuDetection() {
      // Verifica a cada 100ms se o menu está aberto (reduz processamento)
      this.plantonistaMenuInterval = setInterval(() => {
        // console.log('▶️ startPlantonistaMenuDetection', this.$refs.plantonistaSelectRef)

        const selectElement = this.$refs.plantonistaSelectRef;
        if (selectElement) {
          const isMenuOpen = selectElement.isMenuActive;

          // Se o estado mudou
          if (isMenuOpen !== this.isPlantonistaMenuOpen) {
            this.isPlantonistaMenuOpen = isMenuOpen;
          }
        }
      }, 100); // Aumentado de 100ms para 500ms
    },

    // Método para parar a detecção do menu
    stopPlantonistaMenuDetection() {
      if (this.plantonistaMenuInterval) {
        // console.log('🛑 stopPlantonistaMenuDetection');
        clearInterval(this.plantonistaMenuInterval);
        this.plantonistaMenuInterval = null;
      }
    },
  },
}
